// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate, useParams, useLocation } from "react-router-dom";
import {
  Tab,
  Tabs,
  Form,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Popover,
} from "react-bootstrap";
import { Button as MuiButton } from "@mui/material";
import {
  ArrowLeft,
  CalendarDays,
  ChevronDown,
  Church,
  Download,
  FileText,
  FolderOpen,
  Heart,
  Mail,
  Mic2,
  Search,
  ShieldCheck,
  Sparkles,
  Upload,
  UserPlus,
  UserRound,
  Users,
  X,
} from "lucide-react";
import "../../../assets/css/RetreatRosterModern.css";
import "../../../assets/css/LsFormModern.css";
import Select from "react-select";
import RetreatRoastApi from "../../../api/retreatRosterApi";
import AuthApi from "../../../api/authApi";
import RolesApi from "../../../api/rolesApi";
import ServiceApi from "../../../api/serviceApi";
import TalksApi from "../../../api/talksApi";
import CommitteeApi from "../../../api/committeeApi";
import FileUploadModal from "../../../components/FileUploadModal";
import { toast } from "react-toastify";
import CustomDataTable from "../../../components/CustomDataTable";
import Helpers from "../../../components/Helpers";
import DeleteModel from "../../../components/DeleteModal";
import AdminApi from "../../../api/adminApi";
import RetreatApi from "../../../api/retreatApi";
import DirectoryApi from "../../../api/directoryApi";
import SendFileModal from "../../../components/SendFileModal";
import { useCookies } from "react-cookie";
import { utils, writeFile } from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment-timezone";
import Container from "react-bootstrap/Container";
import DatePicker from "react-datepicker";
import Profile from "../../../assets/images/couple-default.png";
import corruptedImg from "../../../assets/images/corrupted-img.png";
import UpdateCouplePopUp from "../../Common/UpdateCouplePopUp";
import Confirmations from "../../../components/Confirmations";
import AlertModal from "../../../components/AlertModal";
import OtherParishModal from "../../../components/OtherParishModal";
import AssignTalkModal from "../../../components/AssignTalkModal";
import { sortParishesByName } from "../../../utils/parishLabels";
import GroupedParishNativeOptions from "../../../components/GroupedParishNativeOptions";
import { useAuthUser } from "../../../hooks/useAuthUser";
import { emailFormatError } from "../../../utils/emailFormat";
import { trimIfOnChangeField } from "../../../utils/trimFormFields";
import { setBrokenImageFallback } from "../../../utils/imageFallback";
import { isProtectedDemoCouple } from "../../../utils/demoAccounts";
import { formatCoupleOptionLabel } from "../../../utils/coupleLabels";
import { useEmailDeliverability } from "../../../hooks/useEmailDeliverability";
import EmailDeliverabilityStatus from "../../../components/EmailDeliverabilityStatus";
import { shouldBlockOnInvalid } from "../../../utils/emailDeliverability";
import CreateRetreatSubAdmin from "../../../components/CreateRetreatSubAdmin";
import PhoneInput from "../../../components/PhoneInput";
import CopyableInput from "../../../components/CopyableInput";

const XLSX = require("xlsx");

const RetreatRoaster = () => {
  const userData = useAuthUser();
  let adminApi = new AdminApi();
  let retreatRoastApi = new RetreatRoastApi();
  let retreatApi = new RetreatApi();
  let committeeApi = new CommitteeApi();
  let directoryApi = new DirectoryApi();
  let navigate = useNavigate();
  const location = useLocation();
  const [cookie, setCookie] = useCookies(["LoveStrongUser"]);
  const [retreatRoastData, setRetreatRoastData] = useState<any[]>([]);
  const [allRoasters, setAllRoasters] = useState<any[]>([]);
  const [retreatRoastLeadData, setRetreatRoastLeadData] = useState<any[]>([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<any>(null);
  const [uploadModalTitle, setUploadModalTitle] = useState("");
  const [existingFileUrl, setExistingFileUrl] = useState("");
  const [total, setTotal] = useState(20);
  const [LoadData, setLoadData] = useState(false);
  const fetchingCount = useRef(0);

  const startLoading = () => {
    fetchingCount.current++;
    setLoadData(true);
  };

  const stopLoading = () => {
    fetchingCount.current--;
    if (fetchingCount.current <= 0) {
      fetchingCount.current = 0;
      setLoadData(false);
    }
  };
  const [totalRoast, setTotalRoast] = useState(10);
  let [searchParams, setSearchParams] = useSearchParams();
  const [searchKey, setSearchKey] = useState(
    () => (location.state as any)?.searchKeyword || "",
  ); //for searching
  const [retreatDetail, setRetreatDetail] = useState("");
  let retreatId = searchParams.get("retreatId");
  let isTemp = false;
  let flag = searchParams.get("flag");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [service_count, Setservice_count] = useState("");
  const [fileType, setFileType] = useState("");
  const [talk_count, Settalk_count] = useState("");
  const [team_count, SetTeam_count] = useState("");
  const [ret_count, Setret_count] = useState("");

  const isRestrictedUser =
    userData?.userRole !== "ADMIN" &&
    (userData?.committeeMember === true ||
      (userData?.access === true && userData?.isDisabled === 0));
  const isRetreatClosed = retreatDetail
    ? Boolean(retreatDetail.retreatCloseStatus)
    : true;
  const shouldHideUI = isRestrictedUser && isRetreatClosed;
  const [roast_id, setRoast_id] = useState("");
  const [spritual_count, setSpritual_count] = useState(0);
  const [spritualDirector_count, setSpritualDirector_count] = useState(0);
  const [lead_count, setLead_count] = useState(0);
  const [emailErrors, setEmailErrors] = useState<Record<string, any>>({});
  const [showRegModal, setShowREgModal] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [allCoupleList, setAllCoupleList] = useState<any[]>([]);
  const [roastersOfCoupleList, setRoastersOfCoupleList] = useState<any[]>([]);
  const [isNewCouple, setIsNewCouple] = useState(false);
  const [roasterCount, setRoasterCount] = useState(0);

  const columns1 = [
    {
      id: "title",
      name: "Retreats",
      selector: (row) => (
        <div className="titleWithDate">
          {userData && userData.userRole === "SUBADMIN" ? (
            <div>
              {row?.parish}
              {row.language
                ? ` (${row.language[0].toUpperCase()}${row.language.slice(1)}) `
                : null}{" "}
              {row.location
                ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
                : ""}
            </div>
          ) : (
            <a
              href={`/retreatRoster?retreatId=${row.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="retreat_title"
            >
              <div>
                {row?.parish}
                {row.language
                  ? ` (${row.language[0].toUpperCase()}${row.language.slice(1)}) `
                  : null}{" "}
                {row.location
                  ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
                  : ""}
              </div>
            </a>
          )}
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(
              moment(row.dateFrom).format("MMM DD") +
                " - " +
                moment(row.dateTo).format("MMM DD") +
                ", " +
                moment(row.dateFrom).format("YYYY"),
            )}
          >
            <span>
              {moment(row.dateFrom).format("MMM DD") +
                " - " +
                moment(row.dateTo).format("MMM DD") +
                ", " +
                moment(row.dateFrom).format("YYYY")}
            </span>
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      reorder: true,
      width: "300px",
    },
    {
      id: "AttendeeType",
      name: "Type",
      selector: (row) => row && row.attendeeType,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.attendeeType)}
        >
          {row && row.attendeeType == "Team" ? (
            <span className="badge badge-danger">{row.attendeeType}</span>
          ) : (
            <span className="badge badge-success">{row.attendeeType}</span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Role",
      name: "Role",
      selector: (row) => row && row.role,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.role)}
        >
          <span>{row.role ? row.role : ""}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Service Title",
      name: "Service Title",
      selector: (row) => row && row.service,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.service)}
        >
          <span>{row.service ? row.service : ""}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Talk",
      name: "Talk",
      selector: (row) => row && row.talk,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.talk)}
        >
          <span>{row.talk ? row.talk : ""}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "230px",
      style: {
        cursor: "text",
      },
    },
  ];
  const [statusCheck, setStatusCheck] = useState(false);
  const [mailSendStatus, setMailSendStatus] = useState(false);
  const [missingValue, setMissingValue] = useState(false);
  const [spritualDirector, setSpritualDirector] = useState<any>(null);
  const [priestStatus, setPriestStatus] = useState(false);
  const [missingDataLength, setMissingDataLength] = useState("");
  const [activeFilter, setActiveFilter] = useState<any>(null);
  const activeFilterRef = useRef(null);
  const [resetKey, setResetKey] = useState(0);
  const [fileSendLoader, setFileSendLoader] = useState(false);
  const [talkAssignOpen, setTalkAssignOpen] = useState(false);
  // Retreat-admin management (used by "Add Retreat Admin" button)
  const [createRetAdmin, setCreateRetAdmin] = useState(false);
  const [adminEdiUserIdClicked, setAdminEdiUserIdClicked] = useState("");
  const [allCoupleMails, setAllCoupleMails] = useState<any[]>([]);
  const [allCoupleData, setAllCoupleData] = useState<any[]>([]);
  const [removeAccessModal, setRemoveAccessModal] = useState(false);
  const [editIndex, setEditIndex] = useState<any>(null);
  const [retreatAdminData, setRetreatAdminData] = useState({ userEmails: [] });
  const [showStatus, setShowStatus] = useState(false);
  const [alertData, setAlertData] = useState<any[]>([]);
  const [otherParishModalOpen, setOtherParishModalOpen] = useState(false);
  const [sendFileType, setSendFileType] = useState("directory");
  const [data, setData] = useState({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    parishId: "",
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
  });
  const [roasterdData, setRoasterdData] = useState({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    attendeeType: "",
    roleId: null,
    subRoleId: null,
    serviceId: null,
    talkId: null,
    parishId: "",
    retreatId: retreatId,
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
  });
  const hisEmailStatus = useEmailDeliverability(roasterdData.hisEmail);
  const herEmailStatus = useEmailDeliverability(roasterdData.herEmail);

  let authApi = new AuthApi();
  let rolesApi = new RolesApi();
  let serviceApi = new ServiceApi();
  let talksApi = new TalksApi();
  const [parishList, setParishList] = useState([]);
  const [rolesDataList, setrolesDataList] = useState([]);
  const [serviceDataList, setServiceDataList] = useState([]);
  const [talksDataList, setTalksDataList] = useState([]);
  const [alreadyPk, setAlreadyPk] = useState();
  const [validated, setValidated] = useState(false);
  const [oldData, setOldData] = useState([]);
  const [oldValues, setOldValues] = useState([]);
  const [committeeRetreatData, setCommitteeRetreatData] = useState([]);
  const [sendFile, setSendFile] = useState(false);

  const handleShow = (item: any) => {
    setRoast_id(item);
    setShow(true);
    let d = { ...roasterdData };
    d.id = item.id;
    d.primaryKey = item.primaryKey;
    d.hisFirstName = item.hisFirstName;
    d.hisLastName = item.hisLastName;
    d.hisEmail = item.hisEmail;
    d.herFirstName = item.herFirstName;
    d.herLastName = item.herLastName;
    d.herEmail = item.herEmail;
    setRoasterdData(d);
  };

  const handleAgeChanges = (e: any, check: any) => {
    const { name, checked } = e.target;
    if (check === "forRoaster") {
      let o = { ...roasterdData };
      o.under_age_35 = checked ? "YES" : "NO";
      setRoasterdData(o);
    } else {
      let o = { ...data };
      o.under_age_35 = checked ? "YES" : "NO";
      setData(o);
    }
  };

  const handleDatePicker = (e: any, check: any) => {
    if (check === "forRoaster") {
      let o = { ...roasterdData };
      o.anniversary_date = e;
      setRoasterdData(o);
    } else {
      let o = { ...data };
      o.anniversary_date = e;
      setData(o);
    }
  };

  const handleCheckboxChange = (e: any, check: any) => {
    const { name, checked } = e.target;
    if (check === "forRoaster") {
      let hearUsArray = [];
      if (roasterdData.hear_us && roasterdData.hear_us !== "null") {
        if (Array.isArray(roasterdData.hear_us)) {
          hearUsArray = roasterdData.hear_us;
        } else {
          hearUsArray = JSON.parse(roasterdData.hear_us);
        }
      }
      let updatedOptions;
      if (checked) {
        updatedOptions = [...hearUsArray, name];
      } else {
        updatedOptions = hearUsArray.filter((option) => option !== name);
      }
      setRoasterdData({
        ...roasterdData,
        hear_us: cleanHearUsFinal(updatedOptions),
      });
    } else {
      let hearUsArray =
        data.hear_us !== "null"
          ? Array.isArray(data.hear_us)
            ? data.hear_us
            : JSON.parse(data.hear_us)
          : [];

      let updatedOptions;
      if (checked) {
        updatedOptions = hearUsArray ? [...hearUsArray, name] : [name];
      } else {
        updatedOptions = hearUsArray.filter((option) => option !== name);
      }
      setData({ ...data, hear_us: cleanHearUsFinal(updatedOptions) });
    }
  };

  const cleanHearUsFinal = (val: any) => {
    const allowed = [
      "Website",
      "Church Bulletin",
      "Facebook",
      "School Marquee",
      "Pulpit Talk/Table in Church",
    ];

    try {
      while (typeof val === "string") {
        val = JSON.parse(val);
      }

      if (!Array.isArray(val)) return [];

      return val.filter(
        (item) => typeof item === "string" && allowed.includes(item),
      );
    } catch {
      return [];
    }
  };

  const getPerishList = async () => {
    await authApi
      .getPerishList()
      .then((response: any) => {
        setParishList(sortParishesByName(response.data));
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const getrolesList = async () => {
    await rolesApi
      .getAllRoleList()
      .then(async (response: any) => {
        const sortedList = response.data.sort((a, b) =>
          a.role.localeCompare(b.role),
        );
        setrolesDataList(response.data);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const committeeRetreats = async () => {
    await committeeApi
      .committeeAccessedRetreats({ committeeId: userData.id })
      .then(async (response: any) => {
        setCommitteeRetreatData(response.data);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const getServiceList = async () => {
    await serviceApi
      .getAllServiceList()
      .then(async (response: any) => {
        const sortedList = response.data.sort((a, b) =>
          a.service.localeCompare(b.service),
        );
        setServiceDataList(sortedList);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const getTalksList = async () => {
    await talksApi
      .getAllTalkList()
      .then(async (response: any) => {
        const sortedList = response.data.sort((a, b) =>
          a.talk.localeCompare(b.talk),
        );
        setTalksDataList(sortedList);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const assignedTalkIds = React.useMemo(() => {
    return allRoasters
      .filter((item) => item.talkId != null && item.id !== roasterdData?.id)
      .map((item) => Number(item.talkId));
  }, [allRoasters, roasterdData]);

  const clearfield = () => {
    setData({
      id: "",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      city: "",
      state: "",
      zip: "",
      notes: "",
      imageUrl: "",
      parishId: null,
      address: "",
      allergies: "",
      anniversary_date: "",
      under_age_35: "NO",
      emergency_name1: "",
      emergency_relationship1: "",
      emergency_phone1: "",
      emergency_name2: "",
      emergency_relationship2: "",
      emergency_phone2: "",
      hear_us: [],
      referral_from_a_friend_or_family_member: "",
      userRole: "COUPLE",
    });

    setOldValues(null);
    setValidated(false);
  };

  const CloseCompose = () => {
    setIsEditAdmin(false);
    setValidated(false);
    setShowREgModal(false);
    setEdiUserIdClicked("");
    clearfield();
  };

  useEffect(() => {
    getCouplesInRetreat();
    getRetreatRoastData();
    getRetreatRoastData1();
    getRetreatDetail();
    leadCoupleData1();
    checkPKCouple();
    getPerishList();
    spritualDirectorData();
    committeeRetreats();
    if (flag == "1") {
      RetreatData();
    } else if (flag == "2") {
      teamData();
    }
  }, [retreatId]);

  useEffect(() => {
    if (retreatDetail && retreatDetail.title) {
      
    }
  }, [retreatDetail.title]);

  const [isTempUpload, setIsTempUpload] = useState(false);

  const getCouplesInRetreat = async () => {
    startLoading();
    await retreatRoastApi
      .getCouplesInRetreat({ retreatId: retreatId, isTemp })
      .then((res: any) => {
        if (res.success) {
          let retreatCouple = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.primaryKey) {
                retreatCouple.push({
                  label:
                    `(${
                      item && item.primaryKey ? `${item.primaryKey} - ` : ""
                    }` +
                    `${item && item.hisLastName ? `${item.hisLastName}` : ""}` +
                    `${
                      item && item.hisFirstName ? `, ${item.hisFirstName}` : ""
                    }` +
                    `${
                      item && item.herFirstName
                        ? ` and  ${item.herFirstName}`
                        : ""
                    })`,
                  value: item.id,
                });
              }
            });

          setAllCoupleList(retreatCouple);
          stopLoading();
        } else {
          stopLoading();
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const checkPKCouple = async () => {
    await authApi
      .checkPKCouple()
      .then((res: any) => {
        if (res.success) {
          if (res.data != null) {
            let incPK = res.data + 1;
            setAlreadyPk(incPK);
            let d = { ...data };
            let d1 = { ...roasterdData };
            d.primaryKey = incPK;
            d1.primaryKey = incPK;
            setRoasterdData(d1);
            setData(d);
          } else {
            let defaultPK = 1001;
            setAlreadyPk(defaultPK);
            let d = { ...data };
            let d1 = { ...roasterdData };
            d1.primaryKey = defaultPK;
            d.primaryKey = defaultPK;
            setRoasterdData(d1);
            setData(d);
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
        // console.log('error: ', error);
      });
  };

  const getroastersOfCouple = async (id) => {
    await adminApi
      .participatedInRetreats({ couple_Id: id })
      .then(async (response) => {
        setRoastersOfCoupleList(response.data);
        setRoasterCount(response.totalRecords);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const upload = () => {
    document.getElementById("CoupleProfileUpload").click();
    setIsTempUpload(true);
  };

  const remove1 = () => {
    let d = { ...roasterdData };
    let o = { ...oldData };
    d.imageUrl = "";
    o.imageUrl = "";
    setRoasterdData(d);
    setIsTempUpload(false);
    setOldData(o);
  };

  const editCouple = async (id) => {
    // setIsDisabled(true)
    setEdiUserIdClicked(id);
    setIsTempUpload(false);
    let d = { ...data };
    await adminApi
      .getCouplesDetail({ coupleId: id })
      .then(async (res) => {
        if (isProtectedDemoCouple(res.data[0].hisEmail, res.data[0].herEmail)) {
          setIsEditAdmin(true);
        }
        if (res.success) {
          d.id = res.data[0].id;
          d.primaryKey = res.data[0].primaryKey;
          d.hisFirstName = res.data[0].hisFirstName;
          d.hisLastName = res.data[0].hisLastName;
          d.hisEmail = res.data[0].hisEmail;
          d.hisMobile = res.data[0].hisMobile;
          d.herFirstName = res.data[0].herFirstName;
          d.herLastName = res.data[0].herLastName;
          d.herEmail = res.data[0].herEmail;
          d.herMobile = res.data[0].herMobile;
          d.city = res.data[0].city;
          d.state = res.data[0].state;
          d.zip = res.data[0].zip;
          d.notes = res.data[0].notes;
          d.parishId = res.data[0].parishId;
          d.imageUrl = res.data[0].imageUrl;
          d.address = res.data[0].address;
          d.allergies = res.data[0].allergies;
          d.anniversary_date = res.data[0].anniversary_date
            ? new Date(res.data[0].anniversary_date)
            : "";
          d.under_age_35 = res.data[0].under_age_35;
          d.emergency_name1 = res.data[0].emergency_name1;
          d.emergency_relationship1 = res.data[0].emergency_relationship1;
          d.emergency_phone1 = res.data[0].emergency_phone1;
          d.emergency_name2 = res.data[0].emergency_name2;
          d.emergency_relationship2 = res.data[0].emergency_relationship2;
          d.emergency_phone2 = res.data[0].emergency_phone2;
          d.hear_us = res.data[0].hear_us;
          d.referral_from_a_friend_or_family_member =
            res.data[0].referral_from_a_friend_or_family_member;
          setData(d);
          setOldValues(res.data[0]);
          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getRetreatRoastData = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    arg5 = null,
    arg6 = null,
  ) => {
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else {
      d.searchKeyword = searchKey;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = false;
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    let finalFilter = "";
    if (arg5 !== null && typeof arg5 === "string") {
      finalFilter = arg5;
    } else if (arg6 !== null && typeof arg6 === "string") {
      finalFilter = arg6;
    } else {
      finalFilter = activeFilterRef.current || activeFilter || "";
    }
    d.filterBy = finalFilter;
    startLoading();
    await retreatRoastApi
      .getRetreatRoastData(d)
      .then((res: any) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setRetreatRoastData(res.data);
          Setservice_count(res.servTalkTeamTotal.serviceTotal);
          Settalk_count(res.servTalkTeamTotal.talksTotal);
          SetTeam_count(res.servTalkTeamTotal.countTeam);
          Setret_count(res.servTalkTeamTotal.countret);
          setSpritualDirector_count(
            res?.servTalkTeamTotal?.spiritual_director_count,
          );
          setTotal(totalRecords);
          setTotalRoast(totalRecords);
          stopLoading();
          if (!retreatDetail || retreatDetail === "") {
            getRetreatDetail();
          }
        } else {
          stopLoading();
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const clearFilter = async () => {
    activeFilterRef.current = "";
    setActiveFilter("");
    setSearchKey("");
    setMissingValue(false);
    setResetKey((prev) => prev + 1);
    // Explicitly pass empty search and filter to override state lag
    getRetreatRoastData(1, 20, "", {}, "", "");
  };

  const handleClientSearch = (fullData, keyword) => {
    if (!keyword || keyword.trim() === "") return fullData;
    const key = keyword.toLowerCase();
    return fullData.filter((item) => {
      return (
        (item.hisFirstName && item.hisFirstName.toLowerCase().includes(key)) ||
        (item.hisLastName && item.hisLastName.toLowerCase().includes(key)) ||
        (item.herFirstName && item.herFirstName.toLowerCase().includes(key)) ||
        (item.herLastName && item.herLastName.toLowerCase().includes(key)) ||
        (item.hisEmail && item.hisEmail.toLowerCase().includes(key)) ||
        (item.herEmail && item.herEmail.toLowerCase().includes(key)) ||
        (item.primaryKey && item.primaryKey.toLowerCase().includes(key)) ||
        (item.mainRole && item.mainRole.toLowerCase().includes(key)) ||
        (item.service && item.service.toLowerCase().includes(key)) ||
        (item.talk && item.talk.toLowerCase().includes(key)) ||
        (item.parish && item.parish.toLowerCase().includes(key)) ||
        (item.hisMobile && item.hisMobile.toLowerCase().includes(key)) ||
        (item.herMobile && item.herMobile.toLowerCase().includes(key))
      );
    });
  };

  const applyFilter = async (filterType) => {
    setMissingValue(false);
    activeFilterRef.current = filterType;
    setActiveFilter(filterType);
    getRetreatRoastData(1, 20, searchKey, {}, false, filterType);
  };

  const refreshWithActiveFilter = () => {
    if (activeFilter) {
      applyFilter(activeFilter);
    } else {
      applyFilter("");
      getRetreatRoastData1();
    }
  };

  const spritualDirectorData = async () => {
    let d = {};
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    await retreatRoastApi
      .getSpritualDirectorData(d)
      .then((res: any) => {
        if (res.success) {
          // setRetreatRoastData(res.data);
          // setAllRoasters(res.data);
          // setTotal(res.totalRecords);
          setSpritualDirector(res.data);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const closePriestAlert = async () => {
    setPriestStatus(false);
  };

  const leadCoupleData1 = async () => {
    let d = {};
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    startLoading();
    await retreatRoastApi
      .getLeadCoupleRoastData(d)
      .then((res: any) => {
        if (res.success) {
          setRetreatRoastLeadData(res.data);
          stopLoading();
        } else {
          toast.error(res.msg);
          stopLoading();
        }
      })
      .catch((error: any) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const setStates = async (row) => {
    setEdiUserIdClicked(row.id);
    let d = { ...roasterdData };
    let r = { ...oldData };
    d.id = row && row.id;
    d.primaryKey = row && row.primaryKey;
    d.hisLastName = row && row.hisLastName;
    d.hisFirstName = row && row.hisFirstName;
    d.herFirstName = row && row.herFirstName;
    d.hisEmail = row && row.hisEmail;
    d.hisMobile = row && row.hisMobile;
    d.herLastName = row && row.herLastName;
    d.herEmail = row && row.herEmail;
    d.herMobile = row && row.herMobile;
    d.city = row && row.city;
    d.state = row && row.state;
    d.zip = row && row.zip;
    d.notes = row && row.notes;
    d.imageUrl = row && row.imageUrl;
    d.parishId = row && row.parishId;
    d.attendeeType = row && row.attendeeType;
    d.roleId = row && row.roleId;
    d.subRoleId = row && row.subRoleId;
    d.serviceId = row && row.serviceId;
    d.talkId = row && row.talkId;
    d.coupleId = row && row.coupleId;
    d.address = row && row.address;
    d.mainRole = row && row.mainRole;
    d.allergies = row && row.allergies;
    d.anniversary_date =
      row && row.anniversary_date ? new Date(row && row.anniversary_date) : "";
    d.under_age_35 = row && row.under_age_35;
    d.emergency_name1 = row && row.emergency_name1;
    d.emergency_relationship1 = row && row.emergency_relationship1;
    d.emergency_phone1 = row && row.emergency_phone1;
    d.emergency_name2 = row && row.emergency_name2;
    d.emergency_relationship2 = row && row.emergency_relationship2;
    d.emergency_phone2 = row && row.emergency_phone2;
    d.hear_us = row && row.hear_us;
    d.referral_from_a_friend_or_family_member =
      row && row.referral_from_a_friend_or_family_member;

    setRoasterdData(d);
    setOldValues(row);
    getPerishList();
    getrolesList();
    getServiceList();
    getTalksList();
  };

  const handleChangeRoaster = (e) => {
    let { name, value } = e.target;
    if (typeof value === "string") value = trimIfOnChangeField(name, value);
    let d = { ...roasterdData };
    let o = { ...oldData };
    if (name === "hisFirstName") {
      o.hisFirstName = oldValues && oldValues.hisFirstName;
    } else if (name === "hisLastName") {
      o.hisLastName = oldValues && oldValues.hisLastName;
    } else if (name === "hisEmail") {
      o.hisEmail = oldValues && oldValues.hisEmail;
    } else if (name === "hisMobile") {
      o.hisMobile = oldValues && oldValues.hisMobile;
    } else if (name === "herFirstName") {
      o.herFirstName = oldValues && oldValues.herFirstName;
    } else if (name === "herLastName") {
      o.herLastName = oldValues && oldValues.herLastName;
    } else if (name === "herEmail") {
      o.herEmail = oldValues && oldValues.herEmail;
    } else if (name === "herMobile") {
      o.herMobile = oldValues && oldValues.herMobile;
    } else if (name === "parishId") {
      if (value === "OTHER") {
        setOtherParishModalOpen(true);
      }
      if (value === "") {
        value = retreatDetail.parishId;
      }

      o.parishId = oldValues && oldValues.parishId;
    } else if (name === "notes") {
      o.notes = oldValues && oldValues.notes;
    } else if (name === "zip") {
      o.zip = oldValues && oldValues.zip;
    } else if (name === "city") {
      o.city = oldValues && oldValues.city;
    } else if (name === "state") {
      o.state = oldValues && oldValues.state;
    } else if (name === "imageUrl") {
      o.imageUrl = oldValues && oldValues.imageUrl;
    } else if (name === "attendeeType") {
      o.attendeeType = oldValues && oldValues.attendeeType;
    } else if (name === "roleId") {
      o.roleId = oldValues && oldValues.roleId;
    } else if (name === "subRoleId") {
      o.subRoleId = oldValues && oldValues.subRoleId;
    } else if (name === "serviceId") {
      o.serviceId = oldValues && oldValues.serviceId;
    } else if (name === "talkId") {
      o.talkId = oldValues && oldValues.talkId;
    } else if (name === "retreatId") {
      o.retreatId = oldValues && oldValues.retreatId;
    }
    setOldData(o);
    if (name == "imageUrl") {
      d.imageUrl = e.target.files[0];
      toast.success("The profile image has been successfully added.");
    } else {
      d[name] = value;
    }
    setRoasterdData(d);

    if (name === "hisEmail" || name === "herEmail") {
      setEmailErrors((prev) => ({
        ...prev,
        [name]: emailFormatError(value),
      }));
    }
  };

  const handleRoasterData = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    const hasErrors = Object.values(emailErrors).some((error) => error !== "");
    if (hasErrors) {
      toast.error("Please enter valid email addresses.");
      return;
    }
    if (shouldBlockOnInvalid(hisEmailStatus, herEmailStatus)) {
      toast.error("Please enter a valid email.");
      return;
    }

    if (form.checkValidity()) {
      const hasEmergencyContact1 =
        roasterdData.emergency_name1 &&
        roasterdData.emergency_phone1 &&
        roasterdData.emergency_relationship1;

      const hasEmergencyContact2 =
        roasterdData.emergency_name2 &&
        roasterdData.emergency_phone2 &&
        roasterdData.emergency_relationship2;

      if (!hasEmergencyContact1 && !hasEmergencyContact2) {
        toast.error(
          "Please provide at least one emergency contact with full details.",
        );
        return;
      }
      if (
        ediUserIdClicked &&
        ediUserIdClicked !== "" &&
        ediUserIdClicked !== null
      ) {
        let data1 = new FormData();
        if (roasterdData.imageUrl !== "") {
          data1.append("file", roasterdData.imageUrl);
        }
        let stateRef = { ...roasterdData };
        if (stateRef.parishId === "" || stateRef.parishId === null) {
          stateRef.parishId = retreatDetail.parishId;
        }
        // delete stateRef.imageUrl
        data1.append("fromData", JSON.stringify(stateRef));
        data1.append("isTemp", isTemp);
        retreatRoastApi
          .updateRoaster(data1)
          .then(async (res) => {
            if (res.success) {
              if (res && res.data && res.data[0]) {
                userData.imageUpload =
                  res && res.data && res.data[0] && res.data[0].imageUrl
                    ? res.data[0].imageUrl
                    : "";
                if (userData.coupleId === res.data[0].id) {
                  setCookie("LoveStrongUser", userData, {
                    path: "/",
                    maxAge: 60 * 60 * 100,
                    expires: new Date(Date.now() + 60 * 60 * 100),
                  });
                }
                toast.success(res.msg);
                if (
                  oldData.hisFirstName ||
                  (oldData.hisFirstName === "" &&
                    oldData.hisFirstName !== res.data[0].hisFirstName)
                ) {
                  
                }
                if (
                  oldData.hisLastName ||
                  (oldData.hisLastName === "" &&
                    oldData.hisLastName !== res.data[0].hisLastName)
                ) {
                  
                }

                if (
                  oldData.hisEmail ||
                  (oldData.hisEmail === "" &&
                    oldData.hisEmail !== res.data[0].hisEmail)
                ) {
                  
                }

                if (
                  oldData.hisMobile ||
                  (oldData.hisMobile === "" &&
                    oldData.hisMobile !== res.data[0].hisMobile)
                ) {
                  
                }

                if (
                  oldData.herFirstName ||
                  (oldData.herFirstName === "" &&
                    oldData.herFirstName !== res.data[0].herFirstName)
                ) {
                  
                }

                if (
                  oldData.herLastName ||
                  (oldData.herLastName === "" &&
                    oldData.herLastName !== res.data[0].herLastName)
                ) {
                  
                }

                if (
                  oldData.herEmail ||
                  (oldData.herEmail === "" &&
                    oldData.herEmail !== res.data[0].herEmail)
                ) {
                  
                }
                if (
                  oldData.herMobile ||
                  (oldData.herMobile === "" &&
                    oldData.herMobile !== res.data[0].herMobile)
                ) {
                  
                }
                if (
                  oldData.notes ||
                  (oldData.notes === "" && oldData.notes !== res.data[0].notes)
                ) {
                  
                }
                if (
                  oldData.zip ||
                  (oldData.zip === "" && oldData.zip !== res.data[0].zip)
                ) {
                  
                }
                if (
                  oldData.city ||
                  (oldData.city === "" && oldData.city !== res.data[0].city)
                ) {
                  
                }
                if (
                  oldData.state ||
                  (oldData.state === "" && oldData.state !== res.data[0].state)
                ) {
                  
                }

                if (
                  oldData.imageUrl ||
                  (oldData.imageUrl === "" &&
                    oldData.imageUrl !== res.data[0].imageUrl)
                ) {
                  
                }

                let oldRole = rolesDataList.find(
                  (i) => i.id === oldData.roleId,
                );
                let newRole = rolesDataList.find(
                  (i) => i.id === res.roastData.roleId,
                );
                if (
                  oldData.roleId !== undefined &&
                  (oldData.roleId || oldData.roleId === null)
                ) {
                  
                }

                let oldService = serviceDataList.find(
                  (i) => i.id === oldData.serviceId,
                );
                let newService = serviceDataList.find(
                  (i) => i.id === res.roastData.serviceId,
                );

                if (
                  oldData.serviceId !== undefined &&
                  (oldData.serviceId || oldData.serviceId === null)
                ) {
                  
                }
                let oldTalk = talksDataList.find(
                  (i) => i.talkId == oldData.talkId,
                );
                let newTalk = talksDataList.find(
                  (i) => i.talkId == res.roastData.talkId,
                );
                if (
                  oldData.talkId !== undefined &&
                  (oldData.talkId || oldData.talkId === null)
                ) {
                  
                }
                if (
                  oldData.attendeeType ||
                  (oldData.attendeeType === "" &&
                    oldData.attendeeType !== res.roastData.attendeeType)
                ) {
                  
                }
                let oldparish = parishList.find(
                  (i) => i.id === oldData.parishId,
                );
                let newparish = parishList.find(
                  (i) => i.id === res.data[0].parishId,
                );
                if (
                  oldData.parishId !== undefined &&
                  (oldData.parishId || oldData.parishId === null)
                ) {
                  
                }
                setOldData(null);
                clearfield();
                setRoasterdData({
                  id: "",
                  hisFirstName: "",
                  hisLastName: "",
                  hisEmail: "",
                  hisMobile: "",
                  herFirstName: "",
                  herLastName: "",
                  herEmail: "",
                  herMobile: "",
                  city: "",
                  state: "",
                  zip: "",
                  notes: "",
                  imageUrl: "",
                  attendeeType: "",
                  roleId: null,
                  subRoleId: null,
                  serviceId: null,
                  talkId: null,
                  retreatId: retreatId,
                  parishId: "",
                });
                setShowModel(false);
                setShowModel(false);
                setResetKey((prev) => prev + 1);
                refreshWithActiveFilter();
                getRetreatRoastData1();
                spritualDirectorData();
                leadCoupleData1();
                setIsTempUpload(false);
                // setIsTempUpload2(false);
                setIsNewCouple(false);
                getCouplesInRetreat();
              }
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error: any) => {
            toast.error(error);
          });
      } else {
        let data1 = new FormData();
        data1.append("file", roasterdData.imageUrl);
        let stateRef = { ...roasterdData };
        if (stateRef.parishId === "" || stateRef.parishId === null) {
          stateRef.parishId = retreatDetail.parishId;
        }
        delete stateRef.imageUrl;
        data1.append("fromData", JSON.stringify(stateRef));
        data1.append("isTemp", isTemp);
        retreatRoastApi
          .CreateRoaster(data1)
          .then(async (res) => {
            if (res.success) {
              
              toast.success(res.msg);
              clearfield();
              remove1();
              // removeMarriagePhoto1();
              setShowModel(false);
              setShowModel(false);
              setResetKey((prev) => prev + 1);
              refreshWithActiveFilter();
              getRetreatRoastData1();
              spritualDirectorData();
              leadCoupleData1();
              getCouplesInRetreat();
              setRoasterdData({
                id: "",
                hisFirstName: "",
                hisLastName: "",
                hisEmail: "",
                hisMobile: "",
                herFirstName: "",
                herLastName: "",
                herEmail: "",
                herMobile: "",
                city: "",
                state: "",
                zip: "",
                notes: "",
                imageUrl: "",
                attendeeType: "",
                roleId: null,
                subRoleId: null,
                serviceId: null,
                talkId: null,
                retreatId: retreatId,
                parishId: "",
              });
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error: any) => {
            console.log(error);
          });
      }
    }
    setValidated(true);
  };

  const addRoaster = async () => {
    setIsNewCouple(true);
    setShowModel(true);
    getPerishList();
    getrolesList();
    getServiceList();
    getTalksList();
    checkPKCouple();
    await getAllCouples();
  };

  const handleSelectCuple = async (val) => {
    if (val.value) {
      let d = { ...roasterdData };
      await adminApi
        .getCouplesDetail({ coupleId: val.value })
        .then(async (res) => {
          if (isProtectedDemoCouple(res.data[0].hisEmail, res.data[0].herEmail)) {
            setIsEditAdmin(true);
          }
          if (res.success) {
            // setEdiUserIdClicked(res.data[0].id);
            d.primaryKey = res.data[0].primaryKey;
            d.hisFirstName = res.data[0].hisFirstName;
            d.hisLastName = res.data[0].hisLastName;
            d.hisEmail = res.data[0].hisEmail;
            d.hisMobile = res.data[0].hisMobile;
            d.herFirstName = res.data[0].herFirstName;
            d.herLastName = res.data[0].herLastName;
            d.herEmail = res.data[0].herEmail;
            d.herMobile = res.data[0].herMobile;
            d.city = res.data[0].city;
            d.state = res.data[0].state;
            d.zip = res.data[0].zip;
            d.notes = res.data[0].notes;
            d.imageUrl = res.data[0].imageUrl;
            d.parishId = res.data[0].parishId;
            d.coupleId = res.data[0].id;
            d.address = res.data[0].address;
            d.allergies = res.data[0].allergies;
            d.anniversary_date = res.data[0].anniversary_date
              ? new Date(res.data[0].anniversary_date)
              : "";
            d.under_age_35 = res.data[0].under_age_35;
            d.emergency_name1 = res.data[0].emergency_name1;
            d.emergency_relationship1 = res.data[0].emergency_relationship1;
            d.emergency_phone1 = res.data[0].emergency_phone1;
            d.emergency_name2 = res.data[0].emergency_name2;
            d.emergency_relationship2 = res.data[0].emergency_relationship2;
            d.emergency_phone2 = res.data[0].emergency_phone2;
            d.hear_us = res.data[0].hear_us;
            d.referral_from_a_friend_or_family_member =
              res.data[0].referral_from_a_friend_or_family_member;
            setRoasterdData(d);
          } else {
            toast.error(res.msg);
          }
        })
        .catch((error: any) => {
          toast.error(error);
        });
    }
  };

  const renderEditRetreatModel = () => {
    const renderRoasterForm = () => (
      <Form
        onSubmit={handleRoasterData}
        noValidate
        validated={validated}
        className="forms-sample ls-form"
      >
        <Modal.Body>
          {isNewCouple ? (
            <div className="ls-form-section">
              <h3 className="ls-form-section-title">Add couple</h3>
              <Row>
              <Col lg={12} md={12} xs={12}>
                <Tabs
                  defaultActiveKey="AddNew"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                >
                  <Tab eventKey="AddNew" title=" Add New">
                    Add New Couple
                  </Tab>

                  <Tab eventKey="AddOld" title="Add Existing Couple">
                    <label htmlFor="type" className="bold">
                      Select Couple from existing Couples list.
                    </label>
                    <Select
                      name="Couples"
                      className="mt-3 ls-form-react-select"
                      options={allCoupleData}
                      // value={selectedLocation}
                      onChange={handleSelectCuple}
                      labelledBy="Select"
                      isSearchable={true}
                      isMulti={false}
                    />
                  </Tab>
                </Tabs>
              </Col>
              </Row>
            </div>
          ) : null}
          <div className="ls-form-section">
            <h3 className="ls-form-section-title">Identity</h3>
            <div className="ls-form-identity">
            <div>
              <Form.Group>
                <Form.Label>Couple Id</Form.Label>
                <Form.Control
                  required
                  size="sm"
                  type="text"
                  name="primaryKey"
                  id="primaryKey"
                  placeholder="Couple Id"
                  value={roasterdData.primaryKey}
                  className="form-control"
                  onChange={(e) => handleChangeRoaster(e)}
                  readOnly
                />
                <Form.Control.Feedback type="invalid">
                  Couple Id is required!
                </Form.Control.Feedback>
              </Form.Group>
              <div className="ls-form-check">
                  <input
                    type="checkbox"
                    className="form-check-input ageLabel"
                    name="under_age_35"
                    id="exampleInputEmail1"
                    checked={roasterdData.under_age_35 === "YES" ? true : false}
                    onChange={(e) => {
                      handleAgeChanges(e, "forRoaster");
                    }}
                  />
                <label className="bold" htmlFor="exampleInputEmail1">
                  If you or your spouse are 35 years of age or younger, click
                  this box
                </label>
              </div>
            </div>
            <div className="ls-form-avatar">
                {roasterdData.imageUrl == "" ||
                roasterdData.imageUrl == undefined ? (
                  <div className="edit-profile-img mandatoryImage mb-2 text-center">
                    <img src={Profile} />
                  </div>
                ) : (
                  <div
                    className={`edit-profile-img ${
                      roasterdData?.imageUrl ? null : "mandatoryImage"
                    } mb-2 text-center`}
                  >
                    {isTempUpload ? (
                      <>
                        <img
                          src={URL.createObjectURL(roasterdData?.imageUrl)}
                          onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                        />
                      </>
                    ) : (
                      <>
                        <img
                          src={roasterdData?.imageUrl}
                          onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                        />
                      </>
                    )}
                  </div>
                )}
                <div className="text-center">
                  {roasterdData.imageUrl == "" ||
                  roasterdData.imageUrl == undefined ? (
                    <>
                      <input
                        name="imageUrl"
                        className="pt-1"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        id="CoupleProfileUpload"
                        onChange={(e) => handleChangeRoaster(e)}
                      />
                      <Button
                        variant="primary"
                        className="mb-1 me-3 text-center"
                        onClick={(e) => {
                          upload();
                        }}
                      >
                        Upload Profile Image
                      </Button>
                    </>
                  ) : (
                    <Button
                      variant="danger"
                      className="mb-1 mt-2 "
                      onClick={(e) => {
                        remove1();
                      }}
                    >
                      Remove
                    </Button>
                  )}
                </div>
            </div>
            </div>
          </div>
          <div className="ls-form-gender-row">
            <div className="ls-form-his">
              <label className="badge badge-outline-primary rounded hisLabel">
                His Info
              </label>
              <div id="his-info">
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.hisFirstName ? null : "highlightField mt-2"
                      }
                    >
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="hisFirstName"
                      id="hisFirstName"
                      placeholder="First Name"
                      value={roasterdData.hisFirstName}
                      className="form-control"
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      FirstName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.hisLastName ? null : "highlightField"
                      }
                    >
                      Last Name
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="hisLastName"
                      id="hisLastName"
                      placeholder="First Name"
                      value={roasterdData.hisLastName}
                      className="form-control"
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      LastName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group col">
                    <Form.Label
                      className={
                        roasterdData.hisEmail ? null : "highlightField"
                      }
                    >
                      His Email <span className="text-danger">*</span>
                    </Form.Label>
                    <CopyableInput
                      // required
                      size="sm"
                      type="text"
                      name="hisEmail"
                      id="hisEmail"
                      placeholder="Email"
                      value={roasterdData.hisEmail}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                      isInvalid={
                        !!emailErrors.hisEmail || hisEmailStatus === "invalid"
                      }
                      isValid={
                        !emailErrors.hisEmail && hisEmailStatus === "valid"
                      }
                    />
                    {emailErrors.hisEmail && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {emailErrors.hisEmail}
                      </span>
                    )}
                    <EmailDeliverabilityStatus status={hisEmailStatus} />
                    <Form.Control.Feedback type="invalid">
                      Email is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group col">
                    <Form.Label
                      className={
                        roasterdData.hisMobile ? null : "highlightField"
                      }
                    >
                      His Mobile (Ex- xxx-xxx-xxxx)
                    </Form.Label>
                    <PhoneInput
                      name="hisMobile"
                      value={roasterdData.hisMobile}
                      onChange={(e) => handleChangeRoaster(e)}
                    />
                  </Form.Group>
                </Col>
              </div>
            </div>
            <div className="ls-form-her">
              <label className="badge badge-outline-primary rounded herLabel">
                Her Info
              </label>
              <div id="her-info">
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herFirstName ? null : "highlightField mt-2"
                      }
                    >
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="herFirstName"
                      id="herFirstName"
                      placeholder="First Name"
                      value={roasterdData.herFirstName}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      FirstName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herLastName ? null : "highlightField"
                      }
                    >
                      Last Name
                    </Form.Label>
                    <Form.Control
                      // required
                      size="sm"
                      type="text"
                      name="herLastName"
                      id="herLastName"
                      placeholder="Last Name"
                      value={roasterdData.herLastName}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                    />
                    <Form.Control.Feedback type="invalid">
                      LastName is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herEmail ? null : "highlightField"
                      }
                    >
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <CopyableInput
                      size="sm"
                      type="text"
                      name="herEmail"
                      id="herEmail"
                      placeholder="Email"
                      value={roasterdData.herEmail}
                      onChange={(e) => handleChangeRoaster(e)}
                      readOnly={isEditAdmin}
                      isInvalid={
                        !!emailErrors.herEmail || herEmailStatus === "invalid"
                      }
                      isValid={
                        !emailErrors.herEmail && herEmailStatus === "valid"
                      }
                    />
                    {emailErrors.herEmail && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {emailErrors.herEmail}
                      </span>
                    )}
                    <EmailDeliverabilityStatus status={herEmailStatus} />
                    <Form.Control.Feedback type="invalid">
                      Email is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12} xs={12}>
                  <Form.Group className="form-group">
                    <Form.Label
                      className={
                        roasterdData.herMobile ? null : "highlightField"
                      }
                    >
                      Her Mobile (Ex- xxx-xxx-xxxx)
                    </Form.Label>
                    <PhoneInput
                      name="herMobile"
                      value={roasterdData.herMobile}
                      onChange={(e) => handleChangeRoaster(e)}
                    />
                  </Form.Group>
                </Col>
              </div>
            </div>
          </div>
          <div className="ls-form-section">
            <h3 className="ls-form-section-title">Address & parish</h3>
            <div className="row">
            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.address ? null : "highlightField"}
              >
                Address
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="address"
                id="address"
                placeholder="Address"
                value={roasterdData.address}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Address is required!
              </Form.Control.Feedback>
            </Form.Group>

            {/* <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <Form.Label
                  className={roasterdData.address ? null : "highlightField"}
                >
                  Address
                </Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="address"
                  id="address"
                  placeholder="Search address"
                  value={roasterdData.address}
                  onChange={handleSearch}
                  autoComplete="off"
                />
                <Form.Control.Feedback type="invalid">
                  Address is required!
                </Form.Control.Feedback>
                {suggestions.length > 0 && (
                  <ul
                    className="list-group position-absolute w-100 mt-1"
                    style={{
                      zIndex: 1000,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {suggestions.map((address) => (
                      <li
                        key={address.place_id}
                        onClick={() => handleSelect(address)}
                        className="list-group-item list-group-item-action"
                        style={{ cursor: "pointer" }}
                      >
                        {address.display_name}
                      </li>
                    ))}
                  </ul>
                )}
              </Form.Group> */}

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.state ? null : "highlightField"}
              >
                State
              </Form.Label>
              <Form.Select
                className="form-control minimal"
                size="sm"
                type="text"
                name="state"
                id="state"
                placeholder="State"
                value={roasterdData.state}
                onChange={(e) => handleChangeRoaster(e)}
              >
                <option value="">Select State</option>
                <option value="Alaska">Alaska</option>
                <option value="Alabama">Alabama</option>
                <option value="Arkansas">Arkansas</option>
                <option value="Arizona">Arizona</option>
                <option value="California">California</option>
                <option value="Colorado">Colorado</option>
                <option value="Connecticut">Connecticut</option>
                <option value="District of Columbia">
                  District of Columbia
                </option>
                <option value="Delaware">Delaware</option>
                <option value="Florida">Florida</option>
                <option value="Georgia">Georgia</option>
                <option value="Hawaii">Hawaii</option>
                <option value="Iowa">Iowa</option>
                <option value="Idaho">Idaho</option>
                <option value="Illinois">Illinois</option>
                <option value="Indiana">Indiana</option>
                <option value="Kansas">Kansas</option>
                <option value="Kentucky">Kentucky</option>
                <option value="Louisiana">Louisiana</option>
                <option value="Massachusetts">Massachusetts</option>
                <option value="Maryland">Maryland</option>
                <option value="Maine">Maine</option>
                <option value="Michigan">Michigan</option>
                <option value="Minnesota">Minnesota</option>
                <option value="Missouri">Missouri</option>
                <option value="Mississippi">Mississippi</option>
                <option value="Montana">Montana</option>
                <option value="North Carolina<">North Carolina</option>
                <option value="North Dakota">North Dakota</option>
                <option value="Nebraska">Nebraska</option>
                <option value="New Hampshire">New Hampshire</option>
                <option value="New Jersey">New Jersey</option>
                <option value="New Mexico">New Mexico</option>
                <option value="Nevada">Nevada</option>
                <option value="New York">New York</option>
                <option value="Ohio">Ohio</option>
                <option value="Oklahoma">Oklahoma</option>
                <option value="Oregon">Oregon</option>
                <option value="Pennsylvania">Pennsylvania</option>
                <option value="Puerto Rico">Puerto Rico</option>
                <option value="Rhode Island">Rhode Island</option>
                <option value="South Carolina">South Carolina</option>
                <option value="South Dakota">South Dakota</option>
                <option value="Tennessee">Tennessee</option>
                <option value="Texas">Texas</option>
                <option value="Utah">Utah</option>
                <option value="Virginia">Virginia</option>
                <option value="Vermont">Vermont</option>
                <option value="Washington">Washington</option>
                <option value="Wisconsin">Wisconsin</option>
                <option value="West Virginia">West Virginia</option>
                <option value="Wyoming">Wyoming</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                State is required!
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.city ? null : "highlightField"}
              >
                City
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="city"
                id="city"
                placeholder="City"
                value={roasterdData.city}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                City is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={roasterdData.zip ? null : "highlightField"}
              >
                Zip
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="zip"
                id="zip"
                placeholder="Zip"
                value={roasterdData.zip}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Zip is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={`label-inline ${
                  roasterdData.parishId || retreatDetail.parishId
                    ? ""
                    : "highlightField"
                }`}
              >
                Parish <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                required
                className="form-control minimal"
                size="sm"
                type="text"
                name="parishId"
                id="parishId"
                placeholder="Parish"
                value={roasterdData.parishId || retreatDetail.parishId}
                onChange={(e) => handleChangeRoaster(e)}
              >
                <GroupedParishNativeOptions
                  parishList={parishList}
                  includeNoneOther
                />
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Parish is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={`label-inline ${
                  !roasterdData.anniversary_date &&
                  roasterdData.mainRole !== "Spiritual Mentor"
                    ? "highlightField"
                    : ""
                }`}
              >
                Anniversary Date (Month/Year){" "}
                {roasterdData.mainRole === "Spiritual Mentor" ? null : (
                  <span className="text-danger">*</span>
                )}
              </Form.Label>

              <DatePicker
                required={
                  roasterdData.mainRole === "Spiritual Mentor" ? false : true
                }
                autoComplete="off"
                dateFormat="MM-dd-yyyy"
                placeholderText="mm-dd-yyyy"
                selected={roasterdData && roasterdData.anniversary_date}
                onChange={(e) => handleDatePicker(e, "forRoaster")}
                className="form-select setdate datepicker"
                name="anniversary_date"
                id="anniversary_date"
                maxDate={new Date()}
                showDisabledMonthNavigation
                renderCustomHeader={({
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled,
                }) => {
                  const years = Array.from(
                    { length: 100 },
                    (_, i) => new Date().getFullYear() - i,
                  );
                  const months = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ];

                  return (
                    <div
                      style={{
                        textAlign: "center",
                        paddingBottom: "8px",
                      }}
                    >
                      {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                      <div
                        style={{
                          marginBottom: "10px",
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        {/* Month Dropdown */}
                        <select
                          style={{
                            fontSize: "16px",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                          value={months[date.getMonth()]}
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((month) => (
                            <option key={month} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>

                        {/* Year Dropdown */}
                        <select
                          style={{
                            fontSize: "16px",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                          value={date.getFullYear()}
                          onChange={({ target: { value } }) =>
                            changeYear(value)
                          }
                        >
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* ✅ Optional month navigation below */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                          style={{
                            fontSize: "18px",
                            padding: "2px 8px",
                            cursor: "pointer",
                          }}
                        >
                          {"<"}
                        </button>

                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {months[date.getMonth()]} {date.getFullYear()}
                        </span>

                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                          style={{
                            fontSize: "18px",
                            padding: "2px 8px",
                            cursor: "pointer",
                          }}
                        >
                          {">"}
                        </button>
                      </div>
                    </div>
                  );
                }}
              />
              <Form.Control.Feedback type="invalid">
                Anniversary Date is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="notes"
                id="notes"
                placeholder="Notes"
                value={roasterdData.notes}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Notes is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form.Label
                className={`${roasterdData.allergies ? "" : "highlightField"}`}
              >
                Do you or your spouse have any dietary allergies, dietary
                restrictions or physical limitations?{" "}
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                size="sm"
                type="text"
                name="allergies"
                id="allergies"
                value={roasterdData.allergies}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Please provide dietary allergies, dietary restrictions, or any
                physical limitations.
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          </div>

          <div className="ls-form-section">
            <h3 className="ls-form-section-title">Emergency contacts</h3>
            <p className="ls-form-section-sub">Please provide at least one emergency contact.</p>
            <div className="row mt-3">

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-">
              <Form.Label
                className={`${
                  roasterdData.emergency_name1 ? "" : "highlightField"
                }`}
              >
                Emergency Name 1<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_name1"
                id="emergency_name1"
                placeholder="Name"
                value={roasterdData.emergency_name1}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label
                className={`${
                  roasterdData.emergency_relationship1 ? "" : "highlightField"
                }`}
              >
                Emergency Relationship 1<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_relationship1"
                id="emergency_relationship1"
                placeholder="Relationship"
                value={roasterdData.emergency_relationship1}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label
                className={`${
                  roasterdData.emergency_phone1 ? "" : "highlightField"
                }`}
              >
                Emergency Phone 1<span className="text-danger">*</span>
              </Form.Label>
              <PhoneInput
                name="emergency_phone1"
                value={roasterdData.emergency_phone1}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-">
              <Form.Label>Emergency Name 2</Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_name2"
                id="emergency_name2"
                placeholder="Name"
                value={roasterdData.emergency_name2}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label>Emergency Relationship 2</Form.Label>
              <Form.Control
                // required
                size="sm"
                type="text"
                name="emergency_relationship2"
                id="emergency_relationship2"
                placeholder="Relationship"
                value={roasterdData.emergency_relationship2}
                onChange={(e) => handleChangeRoaster(e)}
              />
              <Form.Control.Feedback type="invalid">
                Relationship is required!
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <Form.Label>Emergency Phone 2</Form.Label>
              <PhoneInput
                name="emergency_phone2"
                value={roasterdData.emergency_phone2}
                onChange={(e) => handleChangeRoaster(e)}
              />
            </Form.Group>
          </div>
          </div>

          <div className="ls-form-section">
            <h3 className="ls-form-section-title">How did you hear about us?</h3>
            <div className="d-flex flex-wrap hear-options">
              <label className="form-check-label ml-sm-2">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Website"
                  value="Website"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Website")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Website",
                    )
                  }
                />
                Website
                <i className="input-helper"></i>
              </label>

              <label className="form-check-label ml-sm-2">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Church Bulletin"
                  value="Church Bulletin"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Church Bulletin")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Church Bulletin",
                    )
                  }
                />
                Church Bulletin
                <i className="input-helper"></i>
              </label>

              <label className="form-check-label ml-sm-2">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Facebook"
                  value="Facebook"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Facebook")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Facebook",
                    )
                  }
                />
                Facebook
                <i className="input-helper"></i>
              </label>

              <label className="form-check-label ml-sm-2">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="School Marquee"
                  value="School Marquee"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("School Marquee")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "School Marquee",
                    )
                  }
                />
                School Marquee
                <i className="input-helper"></i>
              </label>

              <label className="form-check-label ml-sm-2">
                <input
                  type="checkbox"
                  className="form-check-input ageLabel"
                  name="Pulpit Talk/Table in Church"
                  value="Pulpit Talk/Table in Church"
                  onChange={(e) => handleCheckboxChange(e, "forRoaster")}
                  checked={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes("Pulpit Talk/Table in Church")
                  }
                  disabled={
                    roasterdData &&
                    roasterdData.hear_us &&
                    roasterdData.hear_us.includes(
                      roasterdData.hear_us === "Pulpit Talk/Table in Church",
                    )
                  }
                />
                Pulpit Talk/Table in Church
                <i className="input-helper"></i>
              </label>
            </div>
            <Col lg={6} md={6} xs={12} sm={12} className="mt-3 px-0">
            <Form.Label>Referral from a friend/Family member</Form.Label>
            <Form.Group className="form-group">
              <Form.Control
                // required
                size="sm"
                type="text"
                name="referral_from_a_friend_or_family_member"
                placeholder=" Referral from a friend/Family member"
                id="referral_from_a_friend_or_family_member"
                value={roasterdData.referral_from_a_friend_or_family_member}
                className="form-control"
                onChange={(e) => {
                  handleChangeRoaster(e);
                }}
              />
            </Form.Group>
            </Col>
          </div>
          <div className="ls-form-section">
            <h3 className="ls-form-section-title">Roster assignment</h3>
            <Row>
            <Col lg={6} md={6} xs={12}>
              <Form.Group className="form-group col">
                <Form.Label
                  className={
                    roasterdData.attendeeType ? null : "highlightField"
                  }
                >
                  Attendee Type <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  type="text"
                  name="attendeeType"
                  id="attendeeType"
                  value={roasterdData && roasterdData.attendeeType}
                  onChange={(e) => handleChangeRoaster(e)}
                  required
                >
                  <option value="">Select Attendee Type</option>
                  <option value="Team">Team</option>
                  <option value="Retreatant">Retreatant</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Attendee Type is required!
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col lg={6} md={6} xs={6}>
              <Form.Group className="form-group col">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  type="text"
                  name="roleId"
                  id="roleId"
                  value={roasterdData?.roleId || ""}
                  onChange={(e) => handleChangeRoaster(e)}
                >
                  <option value="">No Role</option>
                  {(() => {
                    const combinedRoles = rolesDataList.filter(
                      (item) =>
                        item.role === "Co-Head" ||
                        item.role === "Head" ||
                        (roasterdData?.roleId &&
                          roasterdData.roleId === item.id),
                    );
                    const uniqueRoles = [
                      ...new Map(
                        combinedRoles.map((item) => [item.id, item]),
                      ).values(),
                    ].sort((a, b) => {
                      if (a.role === "Head") return -1;
                      if (b.role === "Head") return 1;
                      if (a.role === "Co-Head") return -1;
                      if (b.role === "Co-Head") return 1;
                      return 0;
                    });

                    return uniqueRoles.map((item) => (
                      <option key={`role-${item.id}`} value={item.id}>
                        {item.role}
                      </option>
                    ));
                  })()}
                </Form.Select>
              </Form.Group>
            </Col>
            {/* 
              {(() => {
                const selectedRole = rolesDataList.find(
                  (r) => String(r.id) === String(roasterdData?.roleId),
                );
                const isHeadSelected = selectedRole?.role === "Head";
                return isHeadSelected ? (
                  <Col lg={3} md={3} xs={6}>
                    <Form.Group className="form-group col">
                      <Form.Label>Sub-Role</Form.Label>
                      <Form.Select
                        className="form-control minimal"
                        size="sm"
                        name="subRoleId"
                        value={roasterdData?.subRoleId || ""}
                        onChange={(e) => handleChangeRoaster(e)}
                      >
                        <option value="">No Sub-Role</option>
                        {rolesDataList
                          .filter((item) => item.role === "Co-Head")
                          .map((item) => (
                            <option key={`subrole-${item.id}`} value={item.id}>
                              {item.role}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                ) : null;
              })()} */}

            <Col lg={6} md={6} xs={12}>
              <Form.Group className="form-group col">
                <Form.Label>Service Title</Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  type="text"
                  name="serviceId"
                  id="serviceId"
                  value={roasterdData && roasterdData.serviceId}
                  onChange={(e) => handleChangeRoaster(e)}
                >
                  <option value="">No Service Title</option>
                  {serviceDataList.length
                    ? serviceDataList.map((item) => {
                        return (
                          <option
                            key={`serviceTitle-${item.id}`}
                            value={item.id}
                          >
                            {item.service}
                          </option>
                        );
                      })
                    : " "}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Service is required!
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col lg={6} md={6} xs={12}>
              <Form.Group className="form-group col">
                <Form.Label>Talk</Form.Label>
                <Form.Select
                  className="form-control minimal"
                  size="sm"
                  name="talkId"
                  id="talkId"
                  value={roasterdData?.talkId ?? ""}
                  onChange={handleChangeRoaster}
                >
                  <option value="">No Talk</option>

                  {talksDataList.map((item) => {
                    const isUsed = assignedTalkIds.includes(
                      Number(item.talkId),
                    );

                    return (
                      <option
                        key={`talk-${item.talkId}`}
                        value={item.talkId}
                        disabled={isUsed}
                      >
                        {item.talk} {isUsed ? "(Already assigned)" : ""}
                      </option>
                    );
                  })}
                </Form.Select>

                <Form.Control.Feedback type="invalid">
                  Talk is required!
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit">
            {ediUserIdClicked && ediUserIdClicked !== "" ? "Update" : "Submit"}
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModel(false);
              setEdiUserIdClicked("");
              setRoasterdData("");
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Form>
    );

    const renderCoupleRetreatsTab = () => (
      <Modal.Body>
        <div className="ls-form-section">
          <h3 className="ls-form-section-title">Retreat history</h3>
          <p className="ls-form-section-sub">Total Retreats: {roasterCount}</p>
          <div className="modal_table">
            <CustomDataTable
              data={roastersOfCoupleList}
              columns={columns1}
              pointerOnHover={true}
              highlightOnHover={true}
            />
          </div>
        </div>
      </Modal.Body>
    );

    return (
      <Modal
        show={showModel}
        onHide={() => {
          setShowModel(false);
          setEdiUserIdClicked("");
          setRoasterdData("");
          setEdiUserIdClicked("");
        }}
        size="lg"
        centered
        contentClassName="ls-form-modal-content"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            {retreatDetail && retreatDetail.title
              ? `${
                  retreatDetail &&
                  retreatDetail.title &&
                  retreatDetail.title.charAt(0).toUpperCase() +
                    retreatDetail.title.slice(1)
                }, `
              : null}
            {retreatDetail?.dateFrom && retreatDetail?.dateFrom == retreatDetail?.dateTo
              ? moment(retreatDetail && retreatDetail.dateFrom).format(
                  "MMM-DD-YYYY",
                )
              : moment(retreatDetail && retreatDetail.dateFrom).format(
                  "MMM DD",
                ) +
                " - " +
                moment(retreatDetail && retreatDetail.dateTo).format("MMM DD") +
                ", " +
                moment(retreatDetail && retreatDetail.dateTo).format("YYYY")}
          </Modal.Title>
        </Modal.Header>

        {isNewCouple ? (
          renderRoasterForm()
        ) : (
          <Tabs
            defaultActiveKey="Form"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="Form" title="Couple Details">
              {renderRoasterForm()}
            </Tab>
            <Tab eventKey="Retreats" title="Retreats" className="tab-content">
              {renderCoupleRetreatsTab()}
            </Tab>
          </Tabs>
        )}
      </Modal>
    );
  };

  const serviceData = () => applyFilter("service");
  const talkData = () => applyFilter("talk");
  const RetreatData = () => applyFilter("retreatant");
  const spritualData = () => applyFilter("spiritualMentor");
  const leadCoupleData = () => applyFilter("leadCouple");
  const teamData = () => applyFilter("team");

  const getRetreatRoastData1 = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    loadCount = false,
  ) => {
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else {
      d.searchKeyword = searchKey;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = true;
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    startLoading();
    await retreatRoastApi
      .getRetreatRoastData(d)
      .then((res: any) => {
        if (res.success) {
          setAllRoasters(res.data);
          const requiredFields = new Set([
            "attendeeType",
            "hisFirstName",
            "hisLastName",
            "herFirstName",
            "herLastName",
            "hisEmail",
            "herEmail",
            "hisMobile",
            "herMobile",
            "city",
            "state",
            "zip",
            "address",
            "anniversary_date",
            "imageUrl",
            "allergies",
          ]);
          const invalidData = res.data.filter((item) => {
            const hasEmergencyContact1 =
              item.emergency_name1 &&
              item.emergency_phone1 &&
              item.emergency_relationship1;

            const hasEmergencyContact2 =
              item.emergency_name2 &&
              item.emergency_phone2 &&
              item.emergency_relationship2;

            const missingEmergencyContact =
              !hasEmergencyContact1 && !hasEmergencyContact2;

            let missingRequiredField = false;

            if (item.mainRole === "Spiritual Mentor") {
              const hasHis =
                item.hisFirstName && item.hisEmail && item.hisMobile;
              const hasHer =
                item.herFirstName && item.herEmail && item.herMobile;
              const hasAtLeastOne = hasHis || hasHer;

              const commonFields = [
                "attendeeType",
                "city",
                "state",
                "zip",
                "address",
                "imageUrl",
                "allergies",
              ];

              const missingCommonField = commonFields.some(
                (field) => !item[field] || item[field].toString().trim() === "",
              );

              missingRequiredField = !hasAtLeastOne || missingCommonField;
            } else {
              missingRequiredField = [...requiredFields].some(
                (field) => !item[field] || item[field].toString().trim() === "",
              );
            }

            return missingRequiredField || missingEmergencyContact;
          });

          setMissingDataLength(invalidData.length);
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          let spcount = 0;
          let lccount = 0;
          res.data.map((i) => {
            if (i.mainRole === "Spiritual Mentor") {
              spcount = spcount + 1;
            }
            if (i.mainRole === "Lead") {
              lccount = lccount + 1;
            }
          });
          setSpritual_count(spcount);
          setSpritualDirector_count(
            res?.servTalkTeamTotal?.spiritual_director_count,
          );
          setLead_count(lccount);
          stopLoading();
        } else {
          stopLoading();
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const getRetreatDetail = async () => {
    startLoading();
    await retreatApi
      .getRetreatDetail({ id: retreatId, isTemp: isTemp })
      .then(async (response) => {
        const { schedule, ...rest } = response.data[0];
        const parsedSchedule = schedule ? JSON.parse(schedule) : [];
        const parsedData = {
          ...rest,
          freeze: isTemp ? "UNFREEZE" : rest.freeze,
          schedule: parsedSchedule.map((entry) => ({
            date: new Date(entry.date),
            from: entry.from,
            to: entry.to,
          })),
        };
        setRetreatDetail(parsedData);
        stopLoading();
      })
      .catch((error: any) => {
        stopLoading();
        toast.error(error.toString());
      });
  };

  const DeleteData = async () => {
    await retreatRoastApi
      .deleteRetreatRoast({ id: roast_id.id, isTemp })
      .then(async (response) => {
        refreshWithActiveFilter();
        getRetreatRoastData1();
        spritualDirectorData();
        setShow(false);
        setRoast_id("");
        leadCoupleData1();
        toast.success(response.msg);
        
      })
      .catch((error: any) => {
        setShow(false);
        setRoast_id("");
        leadCoupleData1();
        toast.error(error.toString());
      });
  };

  const clickOnInputFile = () => {
    document.getElementById("fileUpload").click();
  };

  function isXLSXFile(file) {
    return file.name.endsWith(".xlsx");
  }

  const fileChangeListener = (event) => {
    let files = [];
    files = event.target.files;
    if (files && files.length && isXLSXFile(files[0])) {
      const input = event.target;
      const reader = new FileReader();
      reader.readAsBinaryString(input.files[0]);

      reader.onload = (e) => {
        const xlsxData = reader.result;
        processXLSXContactRecord(xlsxData);
      };
      reader.onerror = function () {
        alert("Unable to read " + input.files[0]);
        toast.error(`Unable to read ${input.files[0]} `);
        // setProcessing(false);
      };
    } else {
      toast.error("Please import valid .xlsx file.");
      // this.errorMsg = "Please import valid .xlsx file.";
      // fileReset();
    }
  };

  const ImportFileHeader = {
    A: "Couple Id",
    B: "Type",
    C: "His Last Name",
    D: "His First Name",
    E: "Her Last Name",
    F: "Her First Name",
    G: "His Email",
    H: "Her Email",
    I: "His Mobile",
    J: "Her Mobile",
    K: "Service Role",
    L: "Service Title",
    M: "Talk",
    N: "Address",
    O: "City",
    P: "State",
    Q: "Zip",
    R: "Parish",
    S: "Anniversary Date",
    T: "Dietary Restrictions Or Physical Limitations",
    U: "Under Age 35",
    V: "Emergency Name1",
    W: "Emergency Relationship1",
    X: "Emergency Phone1",
    Y: "Emergency Name2",
    Z: "Emergency Relationship2",
    AA: "Emergency Phone2",
    AB: "How did you hear about us?",
    AC: "Referral from a friend/family member",
    AD: "Notes",
  };

  const processXLSXContactRecord = (xlsxRecordsArray) => {
    try {
      const workbook = XLSX.read(xlsxRecordsArray, {
        type: "binary",
        cellDates: true,
      });
      const sheet_name_list = workbook.SheetNames;
      const data = [];
      const headers = {};
      sheet_name_list.forEach(function (y) {
        const worksheet = workbook.Sheets[y];
        for (let z in worksheet) {
          if (z[0] === "!") continue;
          let tt = 0;
          for (let i = 0; i < z.length; i++) {
            if (!isNaN(z[i])) {
              tt = i;
              break;
            }
          }
          const col = z.substring(0, tt);
          const row = parseInt(z.substring(tt));
          const value = worksheet[z].v;
          if (row == 1 && value) {
            headers[col] = value.trim();
            continue;
          }
          if (!data[row]) {
            data[row] = {};
          }
          data[row][headers[col]] = value;
        }
      });
      const importFileHeaderKeys = Object.keys(ImportFileHeader).map((key) =>
        key.toUpperCase(),
      );
      const headersKeys = Object.keys(headers).map((key) => key.toUpperCase());

      if (
        JSON.stringify(importFileHeaderKeys) === JSON.stringify(headersKeys)
      ) {
        if (data && data.length) {
          let importedData = [];
          // if (!data[2]["Couple Id"]) {
          //   toast.error("Couple Id Header is missing in Excel");
          //   return false;
          // }

          let typeSpellError = false;

          for (let index = 2; index < data.length; index++) {
            if (data[index].Type != "Team") {
              if (data[index].Type != "Retreatant") {
                typeSpellError = true;
                break;
              }
            }
          }

          if (typeSpellError) {
            toast.error(
              "There is error in 'Type' column. \n Check spelling of 'Retreatant' or 'Team'",
            );
            return;
          } else {
            data.forEach(function (value, index) {
              if (!value || index < 2) return;
              const hasType = value["Type"] && String(value["Type"]).trim();
              const hasData =
                value["His First Name"] ||
                value["Her First Name"] ||
                value["His Email"] ||
                value["Her Email"];
              if (!hasType || !hasData) return;

              const obj = {};
              if (value["Couple Id"] == "") {
                toast.error(
                  "Couple Id value missing. Check near line " + (index + 1),
                );
                return;
              }
              if (value["Couple Id"]) {
                obj.primaryKey = value["Couple Id"] ? value["Couple Id"] : "";
                obj.attendeeType = value["Type"] ? value["Type"] : "";
                obj.hisFirstName = value["His First Name"]
                  ? value["His First Name"]
                  : "";
                obj.hisLastName = value["His Last Name"]
                  ? value["His Last Name"]
                  : "";
                obj.hisEmail = value["His Email"] ? value["His Email"] : "";
                obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";
                obj.herFirstName = value["Her First Name"]
                  ? value["Her First Name"]
                  : "";
                obj.herLastName = value["Her Last Name"]
                  ? value["Her Last Name"]
                  : "";
                obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
                obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";
                obj.role = value["Service Role"] ? value["Service Role"] : "";
                obj.service = value["Service Title"]
                  ? value["Service Title"]
                  : "";
                obj.talk = value["Talk"] ? value["Talk"] : "";
                obj.address = value["Address"] ? value["Address"] : "";
                obj.city = value["City"] ? value["City"] : "";
                obj.state = value["State"] ? value["State"] : "";
                obj.zip = value["Zip"] ? value["Zip"] : "";
                obj.parish = value["Parish"] ? value["Parish"] : "";

                obj.anniversary_date = value["Anniversary Date"]
                  ? Helpers.convertUtcToTimezone(
                      value["Anniversary Date"],
                      "MM-DD",
                    )
                  : "";
                obj.allergies = value[
                  "Dietary Restrictions Or Physical Limitations"
                ]
                  ? value["Dietary Restrictions Or Physical Limitations"]
                  : "";
                obj.under_age_35 = value["Under Age 35"]
                  ? value["Under Age 35"]
                  : "";
                obj.emergency_name1 = value["Emergency Name1"]
                  ? value["Emergency Name1"]
                  : "";
                obj.emergency_relationship1 = value["Emergency Relationship1"]
                  ? value["Emergency Relationship1"]
                  : "";
                obj.emergency_phone1 = value["Emergency Phone1"]
                  ? value["Emergency Phone1"]
                  : "";
                obj.emergency_name2 = value["Emergency Name2"]
                  ? value["Emergency Name2"]
                  : "";
                obj.emergency_relationship2 = value["Emergency Relationship2"]
                  ? value["Emergency Relationship2"]
                  : "";
                obj.emergency_phone2 = value["Emergency Phone2"]
                  ? value["Emergency Phone2"]
                  : "";

                obj.hear_us =
                  value["How did you hear about us?"] &&
                  value["How did you hear about us?"] !== ""
                    ? [value["How did you hear about us?"]]
                    : [];

                obj.referral_from_a_friend_or_family_member = value[
                  "Referral from a friend/family member"
                ]
                  ? value["Referral from a friend/family member"]
                  : "";

                obj.notes = value["Notes"] ? value["Notes"] : "";
                obj.retreatId = retreatId;
              } else {
                obj.primaryKey = "";
                obj.attendeeType = value["Type"] ? value["Type"] : "";
                obj.hisFirstName = value["His First Name"]
                  ? value["His First Name"]
                  : "";
                obj.hisLastName = value["His Last Name"]
                  ? value["His Last Name"]
                  : "";
                obj.hisEmail = value["His Email"] ? value["His Email"] : "";
                obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";
                obj.herFirstName = value["Her First Name"]
                  ? value["Her First Name"]
                  : "";
                obj.herLastName = value["Her Last Name"]
                  ? value["Her Last Name"]
                  : "";
                obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
                obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";

                obj.role = value["Service Role"] ? value["Service Role"] : "";
                obj.service = value["Service Title"]
                  ? value["Service Title"]
                  : "";
                obj.talk = value["Talk"] ? value["Talk"] : "";
                obj.address = value["Address"] ? value["Address"] : "";
                obj.city = value["City"] ? value["City"] : "";
                obj.state = value["State"] ? value["State"] : "";
                obj.zip = value["Zip"] ? value["Zip"] : "";
                obj.parish = value["Parish"] ? value["Parish"] : "";
                obj.anniversary_date = value["Anniversary Date"]
                  ? Helpers.convertUtcToTimezone(
                      value["Anniversary Date"],
                      "MM-DD",
                    )
                  : "";
                obj.allergies = value[
                  "Dietary Restrictions Or Physical Limitations"
                ]
                  ? value["Dietary Restrictions Or Physical Limitations"]
                  : "";
                obj.under_age_35 = value["Under Age 35"]
                  ? value["Under Age 35"]
                  : "";
                obj.emergency_name1 = value["Emergency Name1"]
                  ? value["Emergency Name1"]
                  : "";
                obj.emergency_relationship1 = value["Emergency Relationship1"]
                  ? value["Emergency Relationship1"]
                  : "";
                obj.emergency_phone1 = value["Emergency Phone1"]
                  ? value["Emergency Phone1"]
                  : "";
                obj.emergency_name2 = value["Emergency Name2"]
                  ? value["Emergency Name2"]
                  : "";
                obj.emergency_relationship2 = value["Emergency Relationship2"]
                  ? value["Emergency Relationship2"]
                  : "";
                obj.emergency_phone2 = value["Emergency Phone2"]
                  ? value["Emergency Phone2"]
                  : "";

                obj.hear_us =
                  value["How did you hear about us?"] &&
                  value["How did you hear about us?"] !== ""
                    ? [value["How did you hear about us?"]]
                    : [];

                obj.referral_from_a_friend_or_family_member = value[
                  "Referral from a friend/family member"
                ]
                  ? value["Referral from a friend/family member"]
                  : "";

                obj.notes = value["Notes"] ? value["Notes"] : "";

                obj.retreatId = retreatId;
              }
              importedData.push(obj);
            });
            saveRetreatRoasterExcel(importedData);
          }
        }
      } else {
        toast.error("Headers are not the same. Please check sample file.");
        return;
      }
    } catch (err) {
      toast.error(err.toString());
    }
  };

  const saveRetreatRoasterExcel = async (importedData) => {
    startLoading();
    const chunkSize = 10000;
    for (let i = 0; i < importedData.length; i += chunkSize) {
      const chunk = importedData.slice(i, i + chunkSize);
      await retreatRoastApi
        .saveRetreatRoasterExcel({ data: chunk, isTemp })
        .then(async (response) => {
          if (response.success) {
            if (response.createdCouple && response.createdCouple.length > 0) {
              await Promise.all(
                response.createdCouple.map(async (item) => {
                  
                }),
              );
            }

            if (response.updateCouple && response.updateCouple.length > 0) {
              await Promise.all(
                response.updateCouple.map(async (item) => {
                  if (item.oldherFirstName != item.newherFirstName) {
                    
                  }

                  if (item.oldherLastName != item.newherLastName) {
                    
                  }

                  if (item.oldherEmail != item.newherEmail) {
                    
                  }

                  if (item.oldherMobile != item.newherMobile) {
                    
                  }

                  if (item.oldhisFirstName != item.newhisFirstName) {
                    
                  }

                  if (item.oldhisLastName != item.newhisLastName) {
                    
                  }

                  if (item.oldhisEmail != item.newhisEmail) {
                    
                  }

                  if (item.oldhisMobile != item.newhisMobile) {
                    
                  }

                  if (item.oldcity != item.newcity) {
                    
                  }

                  if (item.oldstate != item.newstate) {
                    
                  }

                  if (item.oldzip != item.newzip) {
                    
                  }

                  if (item.oldnotes != item.newnotes) {
                    
                  }

                  if (item.oldparish != item.newparish) {
                    
                  }

                  if (item.oldaddress != item.newaddress) {
                    
                  }

                  if (item.oldallergies != item.newallergies) {
                    
                  }

                  if (item.oldanniversary_date != item.newanniversary_date) {
                    
                  }

                  if (item.oldhear_us != item.newhear_us) {
                    
                  }

                  if (item.oldemergency_name1 != item.newemergency_name1) {
                    
                  }

                  if (
                    item.oldemergency_relationship1 !=
                    item.newemergency_relationship1
                  ) {
                    
                  }

                  if (item.oldemergency_phone1 != item.newemergency_phone1) {
                    
                  }

                  if (item.oldemergency_name2 != item.newemergency_name2) {
                    
                  }

                  if (
                    item.oldemergency_relationship2 !=
                    item.newemergency_relationship2
                  ) {
                    
                  }

                  if (item.oldemergency_phone2 != item.newemergency_phone2) {
                    
                  }

                  if (item.oldunder_age_35 != item.newunder_age_35) {
                    
                  }

                  if (
                    item.oldreferral_from_a_friend_or_family_member !=
                    item.newreferral_from_a_friend_or_family_member
                  ) {
                    
                  }
                }),
              );
            }

            if (response.updateRoaster && response.updateRoaster.length > 0) {
              await Promise.all(
                response.updateRoaster.map(async (item) => {
                  if (item.oldRole !== item.newRole) {
                    
                  }

                  if (item.oldTalk !== item.newTalk) {
                    
                  }

                  if (item.oldService !== item.newService) {
                    
                  }

                  if (item.oldAttendeeType !== item.newAttendeeType) {
                    
                  }
                }),
              );
            }

            document.getElementById("fileUpload").value = "";
            toast.success("File data imported successfully.");
            refreshWithActiveFilter();
            leadCoupleData1();
            stopLoading();
          } else {
            document.getElementById("fileUpload").value = "";
            toast.error(response.msg);
            refreshWithActiveFilter();
            leadCoupleData1();
            stopLoading();
          }
        })
        .catch((error: any) => {
          toast.error(error.toString());
          document.getElementById("fileUpload").value = "";
          console.error("There is an error!", error);
        });
    }
  };

  const formatExportRows = (rows) =>
    rows.map((element) => ({
      primaryKey: element.primaryKey,
      attendeeType: element.attendeeType,
      hisLastName: element.hisLastName,
      hisFirstName: element.hisFirstName,
      herLastName: element.herLastName,
      herFirstName: element.herFirstName,
      hisEmail: element.hisEmail,
      herEmail: element.herEmail,
      hisMobile: element.hisMobile,
      herMobile: element.herMobile,
      roleTitle: element.mainRole,
      serviceTitle: element.service,
      talkTitle: element.talk,
      address: element.address,
      city: element.city,
      state: element.state,
      zip: element.zip,
      parish: element.parish,
      parishId: element.uniqueId,
      Anniversary_date:
        element.anniversary_date !== null
          ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
          : "",
      Dietary_restrictions_or_physical_limitations: element.allergies,
      Under_age_35: element.under_age_35,
      Emergency_name1: element.emergency_name1,
      Emergency_relationship1: element.emergency_relationship1,
      Emergency_phone1: element.emergency_phone1,
      Emergency_name2: element.emergency_name2,
      Emergency_relationship2: element.emergency_relationship2,
      Emergency_phone2: element.emergency_phone2,
      Referral_from_a_friend_or_family_member:
        element.referral_from_a_friend_or_family_member,
      notes: element.notes,
    }));

  const exportHeadings = [
    [
      "Couple Id",
      "Type",
      "His Last Name",
      "His First Name",
      "Her Last Name",
      "Her First Name",
      "His Email",
      "Her Email",
      "His Mobile",
      "Her Mobile",
      "Service Role",
      "Service Title",
      "Talk",
      "Address",
      "City",
      "State",
      "Zip",
      "Parish",
      "Parish ID",
      "Anniversary Date",
      "Dietary Restrictions Or Physical Limitations",
      "Under Age 35",
      "Emergency Name1",
      "Emergency Relationship1",
      "Emergency Phone1",
      "Emergency Name2",
      "Emergency Relationship2",
      "Emergency Phone2",
      "Referral from a friend/family member",
      "Notes",
    ],
  ];

  const getExportFileName = () =>
    (retreatDetail?.title
      ? `${retreatDetail.title.charAt(0).toUpperCase()}${retreatDetail.title.slice(1)} `
      : "Retreat Roster ") +
    (retreatDetail?.dateFrom === retreatDetail?.dateTo
      ? moment(retreatDetail?.dateFrom).format("MMM-DD-YYYY")
      : moment(retreatDetail?.dateFrom).format("MMM DD") +
        " - " +
        moment(retreatDetail?.dateTo).format("MMM DD") +
        ", " +
        moment(retreatDetail?.dateTo).format("YYYY"));

  const fetchAllExportData = async () => {
    const d = {
      pageNo: 1,
      size: 20,
      export: true,
      retreatId,
      isTemp: isTemp,
      filterBy: "",
    };
    const res = await retreatRoastApi.getRetreatRoastData(d);
    if (res.success) return res.data;
    toast.error(res.msg);
    return null;
  };

  const exportByTypeExcel = async (attendeeType) => {
    const allData = await fetchAllExportData();
    if (!allData) return;
    const filtered = allData.filter((r) => r.attendeeType === attendeeType);
    const searchedAndFiltered = handleClientSearch(filtered, searchKey);
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, exportHeadings);
    utils.sheet_add_json(ws, formatExportRows(searchedAndFiltered), {
      origin: "A2",
      skipHeader: true,
    });
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, `${getExportFileName()} - ${attendeeType}.xlsx`);
  };
  const exportByTypePdf = async (attendeeType) => {
    const allData = await fetchAllExportData();
    if (!allData) return;
    const filtered = allData.filter((r) => r.attendeeType === attendeeType);
    const searchedAndFiltered = handleClientSearch(filtered, searchKey);

    const doc = new jsPDF("landscape", "pt", "A1");
    doc.setFontSize(15);
    const pdfHeaders = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Parish ID",
        "Anniversary Date",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];
    const pdfData = searchedAndFiltered.map((element) => [
      element.primaryKey,
      element.attendeeType,
      element.hisLastName,
      element.hisFirstName,
      element.herLastName,
      element.herFirstName,
      element.hisEmail,
      element.herEmail,
      element.hisMobile,
      element.herMobile,
      element.mainRole,
      element.service,
      element.talk,
      element.address,
      element.city,
      element.state,
      element.zip,
      element.parish,
      element.uniqueId,
      element.anniversary_date
        ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
        : "",
      element.under_age_35,
      element.emergency_name1,
      element.emergency_relationship1,
      element.emergency_phone1,
      element.emergency_name2,
      element.emergency_relationship2,
      element.emergency_phone2,
      element.referral_from_a_friend_or_family_member,
      element.notes,
    ]);
    doc.text(`${attendeeType} Retreat Roster`, 40, 40);
    doc.autoTable({
      startY: 70,
      head: pdfHeaders,
      body: pdfData,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: "linebreak", // keep this
      },
      columnStyles: {
        27: { cellWidth: 250 }, // 👈 Notes column index (last column)
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: [255, 255, 255],
        fontSize: 8,
      },
      tableWidth: "wrap",
      margin: { left: 40, right: 40 },
    });
    doc.save(`${getExportFileName()} - ${attendeeType}.pdf`);
  };

  const handleExport = async () => {
    let exportData = [];

    if (missingValue) {
      // Use pre-filtered missing data from state
      exportData = retreatRoastData;
    } else {
      // Fetch full data from API
      let d = {
        pageNo: 1,
        size: 20,
        export: true,
        retreatId: retreatId,
        isTemp: isTemp,
        filterBy: "",
      };

      try {
        const res = await retreatRoastApi.getRetreatRoastData(d);
        if (res.success) {
          exportData = res.data;
        } else {
          toast.error(res.msg);
          return;
        }
      } catch (error) {
        toast.error(error);
        return;
      }
    }

    // Format exportData before writing to Excel
    const formattedData = exportData.map((element) => ({
      primaryKey: element.primaryKey,
      attendeeType: element.attendeeType,
      hisLastName: element.hisLastName,
      hisFirstName: element.hisFirstName,
      herLastName: element.herLastName,
      herFirstName: element.herFirstName,
      hisEmail: element.hisEmail,
      herEmail: element.herEmail,
      hisMobile: element.hisMobile,
      herMobile: element.herMobile,
      roleTitle: element.mainRole,
      serviceTitle: element.service,
      talkTitle: element.talk,
      address: element.address,
      city: element.city,
      state: element.state,
      zip: element.zip,
      parish: element.parish,
      parishId: element.uniqueId,
      Anniversary_date:
        element.anniversary_date !== null
          ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
          : "",
      Dietary_restrictions_or_physical_limitations: element.allergies,
      Under_age_35: element.under_age_35,
      Emergency_name1: element.emergency_name1,
      Emergency_relationship1: element.emergency_relationship1,
      Emergency_phone1: element.emergency_phone1,
      Emergency_name2: element.emergency_name2,
      Emergency_relationship2: element.emergency_relationship2,
      Emergency_phone2: element.emergency_phone2,
      Referral_from_a_friend_or_family_member:
        element.referral_from_a_friend_or_family_member,
      notes: element.notes,
    }));

    const headings = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Parish ID",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];

    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, formattedData, {
      origin: "A2",
      skipHeader: true,
    });
    utils.book_append_sheet(wb, ws, "Data");

    const fileName =
      (retreatDetail?.title
        ? `${retreatDetail.title
            .charAt(0)
            .toUpperCase()}${retreatDetail.title.slice(1)} `
        : "Retreat Roster ") +
      (retreatDetail?.dateFrom === retreatDetail?.dateTo
        ? moment(retreatDetail?.dateFrom).format("MMM-DD-YYYY")
        : moment(retreatDetail?.dateFrom).format("MMM DD") +
          " - " +
          moment(retreatDetail?.dateTo).format("MMM DD") +
          ", " +
          moment(retreatDetail?.dateTo).format("YYYY"));

    writeFile(wb, `${fileName}.xlsx`);
  };

  const exportFlockNotes = async () => {
    let d = {};
    d.pageNo = 1;
    d.size = 20;
    d.export = true;
    d.retreatId = retreatId;
    d.isTemp = isTemp;
    d.filterBy = "";
    await retreatRoastApi
      .getRetreatRoastData(d)
      .then(async (res) => {
        if (res.success) {
          let exportData = [];

          res.data.forEach((element) => {
            // Push his data
            exportData.push({
              firstName: element.hisFirstName,
              lastName: element.hisLastName,
              email: element.hisEmail,
              mobile: element.hisMobile,
            });
            // Push her data
            exportData.push({
              firstName: element.herFirstName,
              lastName: element.herLastName,
              email: element.herEmail,
              mobile: element.herMobile,
            });
          });

          const headings = [["First Name", "Last Name", "Email", "Mobile"]];

          const wb = utils.book_new();
          const ws = utils.json_to_sheet([]);
          utils.sheet_add_aoa(ws, headings);
          utils.sheet_add_json(ws, exportData, {
            origin: "A2",
            skipHeader: true,
          });
          utils.book_append_sheet(wb, ws, "Data");

          writeFile(
            wb,
            `${
              retreatDetail && retreatDetail.title
                ? `${
                    retreatDetail.title.charAt(0).toUpperCase() +
                    retreatDetail.title.slice(1)
                  }` +
                  " " +
                  `${
                    retreatDetail?.dateFrom &&
                    retreatDetail.dateFrom === retreatDetail.dateTo
                      ? moment(retreatDetail.dateFrom).format("MMM-DD-YYYY")
                      : moment(retreatDetail.dateFrom).format("MMM DD") +
                        " - " +
                        moment(retreatDetail.dateTo).format("MMM DD") +
                        ", " +
                        moment(retreatDetail.dateTo).format("YYYY")
                  }`
                : "Retreat Roster"
            }.xlsx`,
          );

          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const exportPdf = async () => {
    const unit = "pt";
    const size = "A1"; // large enough for wide tables
    const orientation = "landscape"; // better for many columns
    const marginLeft = 40;

    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    const title = "All Retreat Roster";

    const headers = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Parish ID",
        "Anniversary Date",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];

    let exportSource = [];

    if (missingValue) {
      exportSource = retreatRoastData;
    } else {
      let d = {
        pageNo: 1,
        size: 20,
        export: true,
        retreatId: retreatId,
        filterBy: "",
      };

      try {
        const res = await retreatRoastApi.getRetreatRoastData(d);
        if (res.success) {
          exportSource = res.data;
        } else {
          toast.error(res.msg);
          return;
        }
      } catch (error) {
        toast.error(error);
        return;
      }
    }

    // ✅ Removed allergies, referral_from_a_friend_or_family_member, notes
    const data = exportSource.map((element) => [
      element.primaryKey,
      element.attendeeType,
      element.hisLastName,
      element.hisFirstName,
      element.herLastName,
      element.herFirstName,
      element.hisEmail,
      element.herEmail,
      element.hisMobile,
      element.herMobile,
      element.mainRole,
      element.service,
      element.talk,
      element.address,
      element.city,
      element.state,
      element.zip,
      element.parish,
      element.uniqueId,
      element.anniversary_date
        ? Helpers.convertUtcToTimezone(element.anniversary_date, "MM-DD-YYYY")
        : "",
      element.under_age_35,
      element.emergency_name1,
      element.emergency_relationship1,
      element.emergency_phone1,
      element.emergency_name2,
      element.emergency_relationship2,
      element.emergency_phone2,
      element.referral_from_a_friend_or_family_member,
      element.notes,
    ]);

    const content = {
      startY: 70,
      head: headers,
      body: data,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        cellWidth: "wrap",
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: [255, 255, 255],
        fontSize: 9,
      },
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 50 },
        2: { cellWidth: 80 },
        3: { cellWidth: 80 },
        4: { cellWidth: 80 },
        5: { cellWidth: 80 },
        6: { cellWidth: 120 },
        7: { cellWidth: 120 },
        8: { cellWidth: 80 },
        9: { cellWidth: 80 },
        10: { cellWidth: 80 },
        11: { cellWidth: 80 },
        12: { cellWidth: 80 },
        13: { cellWidth: 100 },
        14: { cellWidth: 60 },
        15: { cellWidth: 60 },
        16: { cellWidth: 50 },
        17: { cellWidth: 80 },
        18: { cellWidth: 60 },
        19: { cellWidth: 60 },
        20: { cellWidth: 80 },
        21: { cellWidth: 80 },
        22: { cellWidth: 80 },
        23: { cellWidth: 90 },
        24: { cellWidth: 80 },
        25: { cellWidth: 90 },
        26: { cellWidth: 90 },
        27: {
          cellWidth: 250,
          overflow: "linebreak",
        },
      },
      tableWidth: "wrap",
      margin: { left: marginLeft, right: 40 },
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);

    const fileName =
      (retreatDetail?.title
        ? `${retreatDetail.title
            .charAt(0)
            .toUpperCase()}${retreatDetail.title.slice(1)} `
        : "Retreat Roster ") +
      (retreatDetail?.dateFrom === retreatDetail?.dateTo
        ? moment(retreatDetail?.dateFrom).format("MMM-DD-YYYY")
        : moment(retreatDetail?.dateFrom).format("MMM DD") +
          " - " +
          moment(retreatDetail?.dateTo).format("MMM DD") +
          ", " +
          moment(retreatDetail?.dateTo).format("YYYY"));

    doc.save(`${fileName}.pdf`);
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const SearchData = (event) => {
    const key = event.target.value;
    setSearchKey(key);
    // Always use server-side fetching, passing null for arg5 to let it use activeFilterRef/State
    getRetreatRoastData(1, 20, key);
  };

  const downloadSampleExcel = async () => {
    const headings = [
      [
        "Couple Id",
        "Type",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "How did you hear about us?",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];
    const data = [
      {
        primaryKey: "001",
        type: "Team",
        hisLastName: "Paul",
        hisFirstName: "Sam",
        herLastName: "Paul",
        herFirstName: " Charisse",
        hisEmail: "sampaul@gmail.com",
        herEmail: "charisseAdams@gmail.com",
        hisMobile: "210-323-0384",
        herMobile: "210-459-4955",
        role: "Co-Head Couple",
        service: "Kitchen",
        talk: "Children and In-Laws",
        address: "101 Balistreri Overpass, Cummerataland, KY 42976",
        city: "Los Angeles",
        state: "California",
        zip_code: "123456",
        parish: "Holy Spirit",
        ainniversary_date: "04-02-2000",
        dietary_restrictions_or_physical_limitations:
          "Dietary restrictions or physical limitations",
        under_age_35: "NO",
        emergency_name_1: "cris",
        emergency_relationship_1: "friend",
        emergency_phone_1: "6445-7645-6786",
        emergency_name_2: "Eric",
        emergency_relationship_2: "Broother",
        emergency_phone_2: "1425-7645-6786",
        hear_about_us: ["School Marquee", "Facebook"],
        Referral_from_a_friend_or_Family_member: "sister",
        notes: "Your notes here.",
      },
      {
        primaryKey: "002",
        type: "Retreatant",
        hisLastName: "Sparow",
        hisFirstName: "Tom",
        herLastName: "Sparow",
        herFirstName: " Zean",
        hisEmail: "tom@gmail.com",
        herEmail: "zean@gmail.com",
        hisMobile: "540-723-0384",
        herMobile: "110-454-4957",
        role: "Lead",
        service: "Music",
        talk: "Marital Bliss",
        address: "Tata Nagar, Opp:ashok Tea House, Deonar (east)",
        city: "Nanwanling	China",
        state: "Tennessee",
        zip_code: "5654756",
        parish: "Holy Spirit",
        ainniversary_date: "07-11-2010",
        dietary_restrictions_or_physical_limitations:
          "Autoimmunity-Immune Deficiency.",
        under_age_35: "NO",
        emergency_name_1: "norman",
        emergency_relationship_1: "father",
        emergency_phone_1: "5656-5657-6786",
        emergency_name_2: "bilosh",
        emergency_relationship_2: "Mother",
        emergency_phone_2: "1425-7645-6786",
        hear_about_us: ["Facebook"],
        Referral_from_a_friend_or_Family_member: "Unle",
        notes: "Your second notes here111.",
      },

      {
        primaryKey: "003",
        type: "Retreatant",
        hisLastName: "Alanis",
        hisFirstName: "Arnulfo",
        herLastName: "Alanis",
        herFirstName: "Millie",
        hisEmail: "arnulfo@gmail.com",
        herEmail: "millie@gmail.com",
        hisMobile: "560-723-4384",
        herMobile: "870-154-4957",
        role: "",
        service: "",
        talk: "",
        address: "Suite 687 3380 Liane Port, Harberberg, OH 95790",
        city: "Nanwanling	China",
        state: "Tennessee",
        zip_code: "5654756",
        parish: "Sts. Peter and Paul",
        ainniversary_date: "07-11-2015",
        dietary_restrictions_or_physical_limitations: "Sinusitis",
        under_age_35: "YES",
        emergency_name_1: "vintrel",
        emergency_relationship_1: "Friend",
        emergency_phone_1: "566-5657-6786",
        emergency_name_2: "orbio",
        emergency_relationship_2: "",
        emergency_phone_2: "3232-7645-6786",
        hear_about_us: ["Facebook", "Church Bulletin"],
        Referral_from_a_friend_or_Family_member: "Unle",
        notes: "Your second notes here111.",
      },

      {
        primaryKey: "004",
        type: "Retreatant",
        hisLastName: "Jamson",
        hisFirstName: "Beon",
        herLastName: "Jamson",
        herFirstName: "Khalisi",
        hisEmail: "beos@gmail.com",
        herEmail: "khalisi@gmail.com",
        hisMobile: "560-723-4384",
        herMobile: "980-154-2957",
        role: "Team Member",
        service: "Tables",
        talk: "Communication",
        address: "Tata Nagar, Opp:ashok Tea House, Deonar (east)",
        city: "Nanwanling	China",
        state: "Tennessee",
        zip_code: "5654756",
        parish: "Holy Spirit",
        ainniversary_date: "07-11-2013",
        dietary_restrictions_or_physical_limitations: "ledi 11 nirmal",
        under_age_35: "NO",
        emergency_name_1: "wisel",
        emergency_relationship_1: "father",
        emergency_phone_1: "5656-5657-6786",
        emergency_name_2: "dekip",
        emergency_relationship_2: "Mother",
        emergency_phone_2: "7878-7645-6786",
        hear_about_us: ["Church Bulletin"],
        Referral_from_a_friend_or_Family_member: "Aunty",
        notes: "Your third notes here111.",
      },
    ];
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, data, { origin: "A2", skipHeader: true });
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, "Sample RetreatRoster File.xlsx");
    
  };

  const popover = (row) => {
    return (
      <Popover id="popover-ImgPk" bsPrefix="popover">
        <Popover.Body>
          <div style={{ textAlign: "center", padding: "10px 0px" }}>
            {row.imageUrl ? (
              <span>
                <img
                  src={row.imageUrl}
                  className="column-rowImagePopover"
                  onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                />
              </span>
            ) : (
              <img src={Profile} className="column-rowImagePopover" />
            )}
            <h6 className="couplename">
              {" "}
              {row &&
                row.hisLastName +
                  ", " +
                  row.hisFirstName +
                  " and " +
                  row.herFirstName}
            </h6>
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const editRoast = async (row) => {
    setIsNewCouple(false);
    setStates(row);
    setOldValues(row);
    setShowModel(true);
    getroastersOfCouple(row.coupleId);
    
  };

  const showActionColumn =
    userData?.userRole === "ADMIN" ||
    (userData?.userRole !== "ADMIN" &&
      retreatDetail &&
      userData?.committeeMember === true &&
      !retreatDetail?.retreatCloseStatus) ||
    (userData?.userRole !== "ADMIN" &&
      retreatDetail &&
      userData?.access === true &&
      userData?.isDisabled === 0 &&
      !retreatDetail?.retreatCloseStatus);

  const columns = [
    ...(showActionColumn
      ? [
          {
            id: "action",
            name: "Action",
            button: true,
            cell: (row) => (
              <>
                <button
                  disabled={row && row.freeze == "FREEZE" ? true : false}
                  className="font-size"
                  onClick={() => {
                    editRoast(row);
                  }}
                >
                  <i
                    className={`mdi mdi-pencil-box text-lg ${
                      row && row.freeze === "FREEZE"
                        ? "editRetreatDisabled"
                        : "editRetreatButton"
                    } font-size`}
                    title="Edit"
                  ></i>
                </button>
                <button
                  disabled={row && row.freeze == "FREEZE" ? true : false}
                  className="font-size"
                  onClick={() => {
                    handleShow(row);
                    setRoasterdData("");
                  }}
                >
                  <i
                    className={`mdi mdi-delete-forever text-md  ${
                      row && row.freeze === "FREEZE"
                        ? "deleteRetreatDisabled"
                        : "deleteRetreatButton"
                    } mx-2 font-size`}
                    title="Delete"
                  ></i>
                </button>
              </>
            ),
            reorder: true,
            width: "100px",
          },
        ]
      : []),

    {
      id: "primaryKey",
      name: "Couple Id",
      selector: (row) => row.primaryKey,
      cell: (row) => (
        <>
          {(row.mainRole == "Spiritual Mentor" && (
            <span className="line2"></span>
          )) ||
            (row.mainRole == "Lead" && <span className="line1"></span>) ||
            (row.attendeeType == "Team" && <span className="line4"></span>) ||
            (row.attendeeType == "Retreatant" && (
              <span className="line3"></span>
            )) || <span className="line5"></span>}
          <OverlayTrigger
            placement="right"
            // delay={{ show: 250, hide: 400 }}
            overlay={popover(row)}
          >
            {/* <span>{row.primaryKey}</span> */}
            {row.imageUrl ? (
              <span
                onClick={
                  shouldHideUI || (row && row.freeze === "FREEZE")
                    ? undefined
                    : () => editRoast(row)
                }
                style={{
                  cursor:
                    shouldHideUI || (row && row.freeze === "FREEZE")
                      ? "default"
                      : "pointer",
                }}
              >
                <span className="roasterKey">
                  <img
                    src={row.imageUrl}
                    className="column-rowImage"
                    onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                  />
                </span>
                {row.primaryKey && row.primaryKey}
              </span>
            ) : (
              <span
                onClick={
                  shouldHideUI || (row && row.freeze === "FREEZE")
                    ? undefined
                    : () => editRoast(row)
                }
                style={{
                  cursor:
                    shouldHideUI || (row && row.freeze === "FREEZE")
                      ? "default"
                      : "pointer",
                }}
              >
                <span className="roasterKey">
                  <img src={Profile} className="column-rowImage-profile" />
                </span>
                {row.primaryKey && row.primaryKey}
              </span>
            )}
          </OverlayTrigger>
        </>
      ),
      sortable: true,
      reorder: true,
      width: "120px",
    },
    {
      id: "Retreatant",
      name: "Type",
      selector: (row) =>
        row && row.attendeeType !== null ? row.attendeeType : "",
      reorder: true,
      sortable: true,
      width: "120px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "his Last Name",
      name: "His Last Name",
      selector: (row) => row.hisLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisLastName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.hisLastName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "his First Name",
      name: "His First Name",
      selector: (row) => row.hisFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisFirstName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.hisFirstName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "Her Last Name",
      name: "Her Last Name",
      selector: (row) => row.herLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herLastName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.herLastName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "her First Name",
      name: "Her First Name	",
      selector: (row) => row.herFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herFirstName)}
        >
          <span
            onClick={
              shouldHideUI
                ? undefined
                : () => {
                    editCouple(row.coupleId);
                    setShowREgModal(true);
                    getroastersOfCouple(row.coupleId);
                  }
            }
            style={{ cursor: shouldHideUI ? "default" : "pointer" }}
          >
            {row.herFirstName}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "His Email",
      name: "His Email",
      selector: (row) => row.hisEmai,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.hisEmail)}
        >
          <a href={`mailto:${row.hisEmail}`}>
            {" "}
            <span>
              {row.hisEmail &&
                row.hisEmail.slice(0, 12) +
                  (row.hisEmail.length > 12 ? "..." : "")}
            </span>{" "}
          </a>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "160px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Her Email",
      name: "Her Email",
      selector: (row) => row.herEmail,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.herEmail)}
        >
          <a href={`mailto:${row.herEmail}`}>
            {" "}
            <span>
              {row.herEmail &&
                row.herEmail.slice(0, 12) +
                  (row.herEmail.length > 12 ? "..." : "")}
            </span>
          </a>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "160px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "His Mobile",
      name: "His Mobile",
      selector: (row) => row.hisMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.hisMobile)}
        >
          <span>{row.hisMobile}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Her Mobile",
      name: "Her Mobile",
      selector: (row) => row.herMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.herMobile)}
        >
          <span>{row.herMobile}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Address",
      name: "Address",
      selector: (row) => row.address,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.address)}
        >
          <span>
            {row.address &&
              row.address.slice(0, 10) + (row.address.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Parish",
      name: "Parish",
      selector: (row) => (row && row.parish !== null ? row.parish : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.parish)}
        >
          <span>{row && row.parish}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "uniqueId",
      name: "Parish ID",
      selector: (row) => (row && row.uniqueId !== null ? row.uniqueId : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row && row.uniqueId)}
        >
          <span>{row && row.uniqueId}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Role",
      name: "Service Role",
      selector: (row) => (row && row.mainRole !== null ? row.mainRole : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.mainRole)}
        >
          <span>{row.mainRole}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
    // {
    //   id: "subRole",
    //   name: "Sub-Role",
    //   selector: (row) => (row && row.subRole !== null ? row.subRole : ""),
    //   cell: (row) => (
    //     <OverlayTrigger
    //       placement="bottom"
    //       delay={{ show: 250, hide: 400 }}
    //       overlay={renderTooltip(row.subRole)}
    //     >
    //       <span>{row.subRole}</span>
    //     </OverlayTrigger>
    //   ),
    //   sortable: true,
    //   reorder: true,
    //   width: "130px",
    //   style: {
    //     cursor: "text",
    //   },
    // },
    {
      id: "Service",
      name: "Service Title",
      selector: (row) => (row && row.service !== null ? row.service : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.service)}
        >
          <span>{row.service}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Talk",
      name: "Talk",
      selector: (row) => (row && row.talk !== null ? row.talk : ""),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.talk)}
        >
          <span>{row.talk}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "190px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.city)}
        >
          <span>
            {row.city &&
              row.city.slice(0, 10) + (row.city.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.state)}
        >
          <span>
            {row.state &&
              row.state.slice(0, 10) + (row.state.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "zip",
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Anniversary Date",
      name: "Anniversary Date",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
          )}
        >
          <span>
            {row.anniversary_date
              ? Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY")
              : "--"}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    /*{
      id: "Dietary restrictions or physical limitations",
      name: "Dietary restrictions or physical limitations",
      selector: (row) => row.allergies,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.allergies)}
        >
          <span>
            {row.allergies &&
              row.allergies.slice(0, 10) +
                (row.allergies.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Name1",
      name: "Emergency Name1",
      selector: (row) => row.emergency_name1,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_name1)}
        >
          <span>
            {row.emergency_name1 &&
              row.emergency_name1.slice(0, 12) +
                (row.emergency_name1.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Relationship1",
      name: "Emergency Relationship1",
      selector: (row) => row.emergency_relationship1,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_relationship1)}
        >
          <span>
            {row.emergency_relationship1 &&
              row.emergency_relationship1.slice(0, 12) +
                (row.emergency_relationship1.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Phone1",
      name: "Emergency Phone1",
      selector: (row) => row.emergency_phone1,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_phone1)}
        >
          <span>
            {row.emergency_phone1 &&
              row.emergency_phone1.slice(0, 12) +
                (row.emergency_phone1.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Name2",
      name: "Emergency Name2",
      selector: (row) => row.emergency_name2,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_name2)}
        >
          <span>
            {row.emergency_name2 &&
              row.emergency_name2.slice(0, 12) +
                (row.emergency_name2.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Relationship2",
      name: "Emergency Relationship2",
      selector: (row) => row.emergency_relationship2,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_relationship2)}
        >
          <span>
            {row.emergency_relationship2 &&
              row.emergency_relationship2.slice(0, 12) +
                (row.emergency_relationship2.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Emergency Phone2",
      name: "Emergency Phone2",
      selector: (row) => row.emergency_phone2,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.emergency_phone2)}
        >
          <span>
            {row.emergency_phone2 &&
              row.emergency_phone2.slice(0, 12) +
                (row.emergency_phone2.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Hear about us",
      name: "Hear about us",
      selector: (row) => row.hear_us,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.hear_us &&
              row.hear_us
                .slice(2, -2)
                .split('","')
                .map((source) => source.replace(/\\"/g, ""))
                .join(", ")
          )}
        >
          <span>
            {row.hear_us &&
              row.hear_us
                .slice(2, -2)
                .split('","')
                .map((source) => source.replace(/\\"/g, ""))
                .join(", ")
                .slice(0, 12) + (row.hear_us.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Referral from a friend/Family member",
      name: "Referral from a friend/Family member",
      selector: (row) => row.referral_from_a_friend_or_family_member,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.referral_from_a_friend_or_family_member)}
        >
          <span>
            {row.referral_from_a_friend_or_family_member &&
              row.referral_from_a_friend_or_family_member.slice(0, 12) +
                (row.referral_from_a_friend_or_family_member.length > 12
                  ? "..."
                  : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Under Age 35",
      name: "Under Age 35",
      selector: (row) => row.under_age_35,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.under_age_35)}
        >
          <span>
            {row.under_age_35 &&
              row.under_age_35.slice(0, 12) +
                (row.under_age_35.length > 12 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "notes",
      name: "Notes",
      selector: (row) => row.notes,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.notes)}
        >
          <span>
            {row.notes &&
              row.notes.slice(0, 10) + (row.notes.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },*/
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "170px",
      style: {
        cursor: "text",
      },
    },
  ];

  const retreatClose = () => {
    retreatApi
      .retreatCloseStatus({ retreatId: retreatDetail.id })
      .then((res: any) => {
        if (res.success) {
          toast.success(res.message);
          getRetreatDetail();
          closeStatusAlert();
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        console.log("error---->", error);

        toast.error("Failed to update retreat status.", error);
      });
  };

  const mailSend = () => {
    retreatApi
      .retreatCloseMailSent({ retreatId: retreatDetail.id })
      .then((res: any) => {
        if (res.success) {
          toast.success(res.message);
          getRetreatDetail();
          closeSendMailAlert();
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        console.log("error---->", error);
        toast.error("Failed to update retreat status.", error);
      });
  };

  const openSendMailAlert = () => {
    if (retreatDetail.confirmedByAdmin) {
      toast.warn("Already confirmed this Retreat.");
    } else {
      setMailSendStatus(true);
    }
  };

  const closeSendMailAlert = () => {
    setMailSendStatus(false);
  };

  const openStatusAlert = () => {
    setStatusCheck(true);
  };

  const closeStatusAlert = () => {
    setStatusCheck(false);
  };

  const missingData = () => {
    const requiredFields = new Set([
      "attendeeType",
      "hisFirstName",
      "hisLastName",
      "herFirstName",
      "herLastName",
      "hisEmail",
      "herEmail",
      "hisMobile",
      "herMobile",
      "city",
      "state",
      "zip",
      "address",
      "anniversary_date",
      "imageUrl",
      "allergies",
    ]);
    const invalidData = allRoasters.filter((item) => {
      // Emergency contact validation
      const hasEmergencyContact1 =
        item.emergency_name1 &&
        item.emergency_phone1 &&
        item.emergency_relationship1;

      const hasEmergencyContact2 =
        item.emergency_name2 &&
        item.emergency_phone2 &&
        item.emergency_relationship2;

      const missingEmergencyContact =
        !hasEmergencyContact1 && !hasEmergencyContact2;

      // Required fields validation
      let missingRequiredField = false;

      if (item.mainRole === "Spiritual Mentor") {
        // Spiritual mentor can be he, she, or couple
        const hasHis = item.hisFirstName && item.hisEmail && item.hisMobile;
        const hasHer = item.herFirstName && item.herEmail && item.herMobile;
        const hasAtLeastOne = hasHis || hasHer;

        const commonFields = [
          "attendeeType",
          "city",
          "state",
          "zip",
          "address",
          "imageUrl",
          "allergies",
        ];

        const missingCommonField = commonFields.some(
          (field) => !item[field] || item[field].toString().trim() === "",
        );

        missingRequiredField = !hasAtLeastOne || missingCommonField;
      } else {
        missingRequiredField = [...requiredFields].some(
          (field) => !item[field] || item[field].toString().trim() === "",
        );
      }

      return missingRequiredField || missingEmergencyContact;
    });
    setAllRoasters(invalidData);
    const displayData = handleClientSearch(invalidData, searchKey);
    setRetreatRoastData(displayData);
    setTotal(displayData.length);
    setMissingValue(true);
  };

  const handleUploadProgram = (retreat) => {
    setSelectedRowId(retreat.id);
    setUploadModalTitle(retreat.title);
    setFileType("programFile");
    setShowUploadModal(true);
    setExistingFileUrl(retreat.programFile);
  };

  const handleUploadDirectory = (retreat) => {
    setSelectedRowId(retreat.id);
    setUploadModalTitle(retreat.title);
    setFileType("directoryFile");
    setShowUploadModal(true); // Show the upload modal
    setExistingFileUrl(retreat.directoryFile);
  };

  const handleUploadModalClose = () => {
    setShowUploadModal(false);
    setSelectedRowId(null); // Reset the row ID(Retreat Id)
    setFileType("");
    setExistingFileUrl("");
    setUploadModalTitle("");
    getRetreatRoastData("");
    getRetreatRoastData1();
  };

  const handleUploadSuccess = () => {
    getRetreatDetail();
  };

  const handleDeleteFile = () => {
    setExistingFileUrl(null);
    getRetreatDetail();
  };

  const openPopUpSendFile = async (type = "directory") => {
    setSendFileType(type);
    setSendFile(true);
    let d = {
      pageNo: 1,
      size: 20,
      export: true,
      retreatId: retreatId,
      filterBy: "",
    };
    try {
      const res = await retreatRoastApi.getRetreatRoastData(d);
      if (res.success) {
        setRetreatRoastData(res.data);
        setAllRoasters(res.data);
      } else {
        toast.error(res.msg);
        return;
      }
    } catch (error) {
      toast.error(error);
      return;
    }
  };

  const sendDirProgFile = async ({ recipientTypes, recipientIds }) => {
    setFileSendLoader(true);
    const selectedSendTo = recipientTypes || [];
    let newRetreatRoaster = [];
    const recipientIdSet =
      recipientIds && Array.isArray(recipientIds)
        ? new Set(recipientIds)
        : new Set();

    // selectedSendTo is now an array: ["Retreatant"], ["Team"], or ["Retreatant", "Team"]
    if (recipientIdSet.size > 0) {
      newRetreatRoaster = allRoasters.filter((item) =>
        recipientIdSet.has(item.id),
      );
    } else if (selectedSendTo.length === 2) {
      // Both selected - send to all
      newRetreatRoaster = allRoasters;
    } else if (selectedSendTo.includes("Team")) {
      // Only Team selected
      newRetreatRoaster = allRoasters.filter((item) => {
        return item.attendeeType === "Team";
      });
    } else if (selectedSendTo.includes("Retreatant")) {
      // Only Retreatant selected
      newRetreatRoaster = allRoasters.filter((item) => {
        return item.attendeeType === "Retreatant";
      });
    }

    if (!selectedSendTo.length) {
      toast.error("Please select at least one recipient type");
      setFileSendLoader(false);
      return;
    }

    if (!newRetreatRoaster.length) {
      toast.error("No recipients found");
      setFileSendLoader(false);
      return;
    }

    await directoryApi
      .sendDirProgMail({
        retreatDetail: retreatDetail,
        sendTo: selectedSendTo.join(" and "), // "Retreatant and Team" or just one
        retreatRoaster: newRetreatRoaster,
        fileType: sendFileType,
      })
      .then((res: any) => {
        if (res.success) {
          closePopUpSendFile();
          toast.success(res.msg);
          setFileSendLoader(false);
        } else {
          toast.error(res.msg);
          setFileSendLoader(false);
        }
      })
      .catch((error: any) => {
        toast.error(error.message || "An error occurred");
        setFileSendLoader(false);
      });
  };

  const closePopUpSendFile = () => {
    setSendFile(false);
    setSendFileType("directory");
  };

  // ------------------------------------------------------------
  // Retreat admin (sub-admin) management
  // ------------------------------------------------------------
  function formatLabel(firstName, lastName, email) {
    let namePart = "";
    if (lastName) namePart += lastName;
    if (firstName) namePart += (lastName ? ", " : "") + firstName;
    return namePart ? `${namePart} - ${email}` : email;
  }

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then(async (res) => {
        if (res.success) {
          let allcoupleList = [];
          let allMailcoupleList = [];

          res.data &&
            res.data.forEach((item) => {
              if (item.hisFirstName || item.hisLastName || item.herFirstName) {
                const emails = [item.hisEmail, item.herEmail]
                  .filter(Boolean)
                  .join(" & ");

                allcoupleList.push({
                  label: formatCoupleOptionLabel(item),
                  value: item.id,
                });
              }

              if (item.hisEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.hisFirstName,
                    item.hisLastName,
                    item.hisEmail,
                  ),
                  value: item.id,
                });
              }

              if (item.herEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.herFirstName,
                    item.herLastName,
                    item.herEmail,
                  ),
                  value: item.id,
                });
              }
            });

          const sort = allcoupleList.sort((a, b) =>
            a.label.localeCompare(b.label),
          );
          setAllCoupleData(sort);

          await adminApi.outerUsers().then((outerRes: any) => {
            if (outerRes.success) {
              outerRes.data &&
                outerRes.data.forEach((item) => {
                  if (item.email) {
                    allMailcoupleList.push({
                      label: item.email,
                      value: item.id,
                    });
                  }
                });
              setAllCoupleMails(allMailcoupleList);
            }
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const editRetreat = async (id) => {
    await retreatApi
      .getRetreatDetail({ id: id, isTemp })
      .then((res: any) => {
        if (res.success) {
          const retreat = res.data?.[0] || {};
          const { schedule, ...rest } = retreat;

          // Keep schedule parsing safe across possible API shapes
          const parsedScheduleRaw =
            schedule && typeof schedule === "string"
              ? JSON.parse(schedule)
              : schedule || [];

          const parsedSchedule = Array.isArray(parsedScheduleRaw)
            ? parsedScheduleRaw.map((entry) => ({
                date: entry?.date ? new Date(entry.date) : null,
                from: entry?.from,
                to: entry?.to,
              }))
            : [];

          setRetreatAdminData({
            ...rest,
            schedule: parsedSchedule,
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const subAdminPopUP = (row) => {
    if (row && row.id) {
      setAdminEdiUserIdClicked(row.id);
      editRetreat(row.id);
      setCreateRetAdmin(true);
    } else {
      toast.error("Please select a retreat first.");
    }
  };

  const handlerAccessRmvShow = (item) => {
    setEditIndex(item);
    setRemoveAccessModal(true);
  };

  const handleAccessRmvClose = () => {
    setRemoveAccessModal(false);
    setEditIndex(null);
  };

  const removeAccessFromRetreat = () => {
    retreatApi
      .removeAccessFromRetreat({
        remove_access_mail: editIndex,
        retreatId: adminEdiUserIdClicked,
        isTemp: isTemp,
      })
      .then((res: any) => {
        toast.success(res.msg);
        // Refresh selected retreat details so modal shows updated admins.
        editRetreat(adminEdiUserIdClicked);
        handleAccessRmvClose();
      })
      .catch((error: any) => {
        console.error(error);
        toast.error("An error occurred while removing the administrator.");
      });
  };

  const openAddRetreatAdminPopUp = async () => {
    const id = retreatDetail?.id || retreatId;
    if (!id) {
      toast.error("Please select a retreat first.");
      return;
    }
    await getAllCouples();
    subAdminPopUP({ id });
  };

  const openAssignPopUp = async () => {
    await getTalksList();
    setTalkAssignOpen(true);
  };

  const closeAssignPopUp = () => setTalkAssignOpen(false);

  const assignTalk = async (assignments) => {
    // assignments = [{ talkId, talkName, rosterId, coupleLabel }, ...]
    // Call your API for each changed assignment
    try {
      for (const a of assignments) {
        await retreatRoastApi.updateRoasterTalk({
          rosterId: a.rosterId,
          talkId: a.talkId,
          isTemp: isTemp,
        });
      }
      toast.success("Talks assigned successfully.");
      refreshWithActiveFilter();
      getRetreatRoastData1();
    } catch (error) {
      toast.error(error.toString());
    }
  };

  const handleShowStatus = (row) => {
    setShowStatus(true);
    setAlertData(row);
  };

  const handleCloseStatus = () => {
    setShowStatus(false);
    setAlertData([]);
  };

  const retreatChangeStatus = () => {
    retreatApi
      .retreatChangeStatus({ alertData: alertData, userData: userData })
      .then((res: any) => {
        handleCloseStatus();
        toast.success(res.message);
        setRetreatDetail(res.data);
        
        toast.success(res.msg);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  return (
    <>
      <div className="rr-roster-page">
        <div className="rr-roster-header">
          <div className="rr-roster-header-left">
            <MuiButton
              className="rr-roster-back"
              onClick={() => navigate("/manageRetreat")}
              startIcon={<ArrowLeft size={16} />}
              sx={{ mb: 0.5, textTransform: "none", px: 0 }}
            >
              Back to Manage Retreats
            </MuiButton>
            <h1 className="rr-roster-title">Retreat Roster</h1>
            {committeeRetreatData && (
              <select
                className="rr-roster-select selectedCommRetreat"
                onChange={(e) => {
                  const retreatId = e.target.value;
                  if (retreatId)
                    navigate(`/retreatRoster?retreatId=${retreatId}`);
                }}
              >
                <option value="" className="retreatOptions">
                  Select Retreat
                </option>

                {committeeRetreatData.map((item, i) => (
                  <option
                    key={item.id}
                    value={item.id}
                    className="retreatOptions"
                  >
                    {`${item.title.slice(0, 30)}${
                      item.title.length > 30 ? "..." : ""
                    } ${moment(item.dateFrom)
                      .tz("America/New_York")
                      .format("MMM DD")} - ${moment(item.dateTo)
                      .tz("America/New_York")
                      .format("MMM DD")}, ${moment(item.dateFrom)
                      .tz("America/New_York")
                      .format("YYYY")}`}
                  </option>
                ))}
              </select>
            )}
            <div className="rr-roster-legend">
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "leadCouple" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--lead"></span>
                <a onClick={leadCoupleData}>Lead Couple</a>
              </span>
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "spiritualMentor" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--mentor"></span>
                <a onClick={spritualData}>Spiritual Mentor</a>
              </span>
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "retreatant" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--retreatant"></span>
                <a onClick={RetreatData}>Retreatant</a>
              </span>
              <span
                className={`rr-roster-legend-item ${
                  activeFilter === "team" ? "is-active" : ""
                }`}
              >
                <span className="rr-roster-dot rr-roster-dot--team"></span>
                <a onClick={teamData}>Team</a>
              </span>
            </div>
          </div>
          <div className="rr-roster-header-actions">
            <a
              onClick={missingData}
              className="rr-roster-btn rr-roster-btn--missing"
            >
              {`Missing Data (${missingDataLength} ${
                missingDataLength == "1" ? "Record" : "Records"
              })`}
            </a>
            {!isTemp && userData?.userRole === "ADMIN" && (
              <>
                <a
                  className="rr-roster-btn rr-roster-btn--outline sendDirectoryProgram"
                  onClick={() => openPopUpSendFile("directory")}
                >
                  <Mail size={16} />
                  Send Directory
                </a>
                <a
                  className="rr-roster-btn rr-roster-btn--outline sendDirectoryProgram"
                  onClick={() => openPopUpSendFile("program")}
                >
                  <FileText size={16} />
                  Send Program
                </a>
              </>
            )}
          </div>
        </div>

        <div className="rr-roster-card">
          <div className="rr-roster-card-top">
            <div className="rr-roster-identity">
              <div className="rr-roster-identity-icon" aria-hidden="true">
                <Church size={18} />
              </div>
              <div className="rr-roster-identity-body">
                <div className="rr-roster-identity-heading">
                  <h3 className="rr-roster-identity-name">
                    {(() => {
                      const data = retreatRoastLeadData?.[0];

                      const hisName = [data?.hisLastName, data?.hisFirstName]
                        .filter(Boolean)
                        .join(", ");

                      const herName = data?.herFirstName || "";

                      if (hisName && herName) {
                        return `${hisName} and ${herName}`;
                      }

                      return hisName || herName || "";
                    })()}
                  </h3>
                  <span
                    className={`rr-roster-status ${
                      Boolean(retreatDetail?.retreatCloseStatus)
                        ? "rr-roster-status--closed"
                        : "rr-roster-status--open"
                    }`}
                  >
                    {Boolean(retreatDetail?.retreatCloseStatus)
                      ? "Retreat Validated & Closed"
                      : "Retreat Open"}
                  </span>
                </div>
                <p className="rr-roster-identity-meta">
                  <a
                    href={`/registration-retreat/${retreatDetail.id}`}
                    target="_blank"
                    title="Retreat registration link"
                  >
                    {retreatDetail?.myparish?.parish ||
                      retreatDetail?.parish?.parish}
                    {retreatDetail.language
                      ? ` (${retreatDetail.language[0].toUpperCase()}${retreatDetail.language.slice(
                          1,
                        )}) `
                      : null}{" "}
                    {retreatDetail.location
                      ? `${retreatDetail.location[0].toUpperCase()}${retreatDetail.location.slice(
                          1,
                        )}`
                      : ""}
                  </a>
                </p>
                <div className="rr-roster-chips-meta">
                  {retreatDetail.dateFrom && retreatDetail.dateTo ? (
                    <span className="rr-roster-meta-chip">
                      <CalendarDays size={13} />
                      {moment(retreatDetail.dateFrom).isSame(
                        retreatDetail.dateTo,
                        "day",
                      )
                        ? moment(retreatDetail.dateFrom)
                            .tz("America/New_York")
                            .format("MMM D, YYYY")
                        : moment(retreatDetail.dateFrom).isSame(
                            retreatDetail.dateTo,
                            "month",
                          )
                          ? `${moment(retreatDetail.dateFrom)
                              .tz("America/New_York")
                              .format("MMM D")} - ${moment(
                              retreatDetail.dateTo,
                            )
                              .tz("America/New_York")
                              .format("D")}, ${moment(retreatDetail.dateFrom)
                              .tz("America/New_York")
                              .format("YYYY")}`
                          : `${moment(retreatDetail.dateFrom)
                              .tz("America/New_York")
                              .format("MMM D")} - ${moment(
                              retreatDetail.dateTo,
                            )
                              .tz("America/New_York")
                              .format("MMM D")}, ${moment(
                              retreatDetail.dateFrom,
                            )
                              .tz("America/New_York")
                              .format("YYYY")}`}
                    </span>
                  ) : null}
                  <a
                    href={`/registration-retreat/${retreatDetail.id}`}
                    target="_blank"
                    title="Retreat registration link"
                    className="rr-roster-meta-chip"
                  >
                    Retreat ID: {retreatDetail.id}
                  </a>
                  <span className="rr-roster-meta-chip">
                    Parish ID:{" "}
                    {retreatDetail?.myparish?.uniqueId ||
                      retreatDetail?.parish?.uniqueId ||
                      retreatDetail?.parishId ||
                      "N/A"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="rr-roster-admin-row">
            <a
              onClick={() =>
                navigate(`/build-my-team?retreatId=${retreatId}`)
              }
              className="rr-roster-btn rr-roster-btn--blue import_button"
              title="Build My Team"
            >
              <Users size={16} />
              Build My Team
            </a>
            {!shouldHideUI && (
              <a
                onClick={openAddRetreatAdminPopUp}
                className="rr-roster-btn rr-roster-btn--green import_button"
                title="Add Retreat Administrators"
              >
                <UserPlus size={16} />
                Add Retreat Admin
              </a>
            )}
            {!shouldHideUI && (
              <a
                onClick={openAssignPopUp}
                className="rr-roster-btn rr-roster-btn--outline impbtn import_button"
              >
                <Mic2 size={16} />
                Assign Talks
              </a>
            )}
            {!isTemp &&
            (userData.email === "jimmieflores@gmail.com" ||
              userData.email === "manpreet02701@gmail.com") ? (
              <span
                className={`rr-roster-btn rr-roster-btn--purple closeMail ${
                  Boolean(retreatDetail?.confirmedByAdmin)
                    ? "is-confirmed closeRet close_color_on"
                    : "reOpenRet close_color_off"
                }`}
                onClick={openSendMailAlert}
                disabled={retreatDetail.confirmedByAdmin}
              >
                <ShieldCheck size={16} />
                <a>
                  {retreatDetail.confirmedByAdmin
                    ? "Retreat Confirmed by Super-Admin"
                    : "Retreat Confirm by Super-Admin"}
                </a>
              </span>
            ) : null}
            {userData?.access === true &&
              userData?.userRole !== "ADMIN" &&
              userData?.isDisabled === 0 &&
              !shouldHideUI && (
                <div className="rr-roster-status-toggle checkStatus">
                  <span>Activate/ Deactivate Retreat</span>
                  <Form.Check
                    className={`switchSize ${
                      retreatDetail.status === "ACTIVE"
                        ? "toggle-on-status"
                        : "toggle-off-status switchColor"
                    }`}
                    type="checkBox"
                    name="status"
                    value={retreatDetail.status}
                    checked={retreatDetail.status === "ACTIVE"}
                    onChange={() => handleShowStatus(retreatDetail)}
                    id="status"
                  />
                </div>
              )}
          </div>

          {!isTemp && (
            <details className="rr-roster-confirmations">
              <summary className="rr-roster-confirm-summary">
                <span>
                  Closing checklist
                  <span className="rr-roster-confirm-count">
                    {
                      [
                        retreatDetail?.confirmation?.[0]?.roasterData,
                        retreatDetail?.confirmation?.[1]?.Directory,
                        retreatDetail?.confirmation?.[2]?.Program,
                        retreatDetail?.confirmation?.[3]?.pictures,
                      ].filter(Boolean).length
                    }
                    /4 confirmed
                  </span>
                </span>
                <ChevronDown size={16} className="rr-roster-confirm-caret" />
              </summary>
              <div className="rr-roster-confirm-head">
                <p className="rr-roster-confirm-hint">
                  Confirm each item below. Closing the retreat unlocks after all
                  four are confirmed.
                </p>
              </div>
              <Confirmations
                missingDataLength={missingDataLength}
                retreatRoastData={allRoasters}
                retreatHeading={retreatDetail}
                handleConfirmStatus={getRetreatDetail}
                userData={userData}
              />
              {!isTemp && userData && userData.userRole === "ADMIN" ? (
                <div
                  className={`rr-roster-close-switch status_btn ${
                    !retreatDetail?.confirmation?.[0]?.roasterData ||
                    !retreatDetail?.confirmation?.[1]?.Directory ||
                    !retreatDetail?.confirmation?.[2]?.Program ||
                    !retreatDetail?.confirmation?.[3]?.pictures
                      ? "is-locked"
                      : "is-ready"
                  }`}
                  title={
                    !retreatDetail?.confirmation?.[0]?.roasterData ||
                    !retreatDetail?.confirmation?.[1]?.Directory ||
                    !retreatDetail?.confirmation?.[2]?.Program ||
                    !retreatDetail?.confirmation?.[3]?.pictures
                      ? "Confirm roster, directory, program, and pictures first"
                      : "Close or reopen this retreat"
                  }
                >
                  <Form.Check
                    disabled={
                      !retreatDetail?.confirmation?.[0]?.roasterData ||
                      !retreatDetail?.confirmation?.[1]?.Directory ||
                      !retreatDetail?.confirmation?.[2]?.Program ||
                      !retreatDetail?.confirmation?.[3]?.pictures
                    }
                    className={`switchSize confirm-toggle mb-0 ${
                      Boolean(retreatDetail?.retreatCloseStatus)
                        ? "toggle-on marginToggle"
                        : "retreat-close-toggle-off"
                    }`}
                    type="switch"
                    id="retreatCloseStatus"
                    checked={Boolean(retreatDetail?.retreatCloseStatus)}
                    onChange={openStatusAlert}
                  />
                  <div>
                    <h6
                      className={`default mb-0 ${
                        Boolean(retreatDetail?.retreatCloseStatus)
                          ? "closeRet  close_color_on"
                          : "reOpenRet close_color_off"
                      }`}
                    >
                      <a>Retreat Validated and Closed</a>
                    </h6>
                    {!(
                      retreatDetail?.confirmation?.[0]?.roasterData &&
                      retreatDetail?.confirmation?.[1]?.Directory &&
                      retreatDetail?.confirmation?.[2]?.Program &&
                      retreatDetail?.confirmation?.[3]?.pictures
                    ) ? (
                      <span className="rr-roster-close-note">
                        Locked until all four confirmations are on
                      </span>
                    ) : (
                      <span className="rr-roster-close-note is-ready">
                        All confirmations complete — you can close this retreat
                      </span>
                    )}
                  </div>
                </div>
              ) : null}
            </details>
          )}
        </div>
        <div className="card custom-card rr-roster-table-card">
          <div className="rr-roster-table-toolbar">
            <div className="rr-roster-search">
              <Search size={16} />
              <input
                onChange={SearchData}
                value={searchKey}
                type="text"
                className="form-control searchData"
                placeholder="Search roster..."
                aria-label="Search roster"
              />
            </div>
            <div
              className="rr-roster-file-group"
              role="group"
              aria-label="Roster files"
            >
              {!shouldHideUI && (
                <a
                  onClick={downloadSampleExcel}
                  className="rr-roster-btn rr-roster-btn--ghost set_text"
                  title="Download Sample Excel"
                >
                  <Download size={15} />
                  Sample
                </a>
              )}
              {((retreatDetail && retreatDetail.freeze === "UNFREEZE") ||
                isTemp) &&
              !shouldHideUI ? (
                <>
                  <a
                    onClick={clickOnInputFile}
                    className="rr-roster-btn rr-roster-btn--ghost impbtn import_button"
                  >
                    <Upload size={16} />
                    Import
                  </a>
                  <input
                    className="btn btn-secondary"
                    type="file"
                    name="File Upload"
                    id="fileUpload"
                    hidden
                    onChange={fileChangeListener}
                    accept=".xlsx"
                  />
                </>
              ) : !shouldHideUI ? (
                <span
                  className={`rr-roster-btn rr-roster-btn--ghost ${
                    retreatDetail && retreatDetail.freeze === "FREEZE"
                      ? "exportHover"
                      : ""
                  } impbtn import_button`}
                >
                  <Upload size={16} />
                  Import
                </span>
              ) : null}
              <Dropdown>
                <Dropdown.Toggle
                  className="rr-roster-btn rr-roster-btn--primary"
                  id="dropdown-basic"
                >
                  <Download size={16} />
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item
                    onClick={() => exportByTypeExcel("Retreatant")}
                  >
                    Export by Retreatant (Excel)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportByTypePdf("Retreatant")}>
                    Export by Retreatant (PDF)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportByTypeExcel("Team")}>
                    Export by Team (Excel)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportByTypePdf("Team")}>
                    Export by Team (PDF)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportFlockNotes}>
                    Flock Note Excel
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleExport}>
                    All data (Excel)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportPdf}>All data (PDF)</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {retreatDetail.freeze === "UNFREEZE" && !shouldHideUI ? (
              <button
                className="rr-roster-btn rr-roster-btn--icon add-user newroaster"
                type="button"
                title="Add New User"
                onClick={() => {
                  setRoasterdData("");
                  addRoaster();
                }}
              >
                <UserPlus size={18} />
              </button>
            ) : null}
          </div>
        {(userData && userData.userRole === "ADMIN") ||
        (userData && userData.committeeMember === true) ||
        (userData &&
          userData.userRole !== "ADMIN" &&
          userData.access === true) ? (
          <div className="rr-roster-filters">
            <div
              className={`rr-roster-chip rr-roster-chip--team ${
                activeFilter === "team" ? "is-active" : ""
              }`}
            >
              <a onClick={teamData}>
                <span className="rr-roster-chip-icon">
                  <Users size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">Team</span>
                  <span className="rr-roster-chip-count">{team_count}</span>
                </span>
              </a>
            </div>
            <div
              className={`rr-roster-chip rr-roster-chip--lead ${
                activeFilter === "leadCouple" ? "is-active" : ""
              }`}
            >
              <a onClick={leadCoupleData}>
                <span className="rr-roster-chip-icon">
                  <Heart size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">Lead Couple</span>
                  <span className="rr-roster-chip-count">{lead_count}</span>
                </span>
              </a>
            </div>
            <div
              className={`rr-roster-chip rr-roster-chip--retreatant ${
                activeFilter === "retreatant" ? "is-active" : ""
              }`}
            >
              <a onClick={RetreatData}>
                <span className="rr-roster-chip-icon">
                  <UserRound size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">Retreatant</span>
                  <span className="rr-roster-chip-count">{ret_count}</span>
                </span>
              </a>
            </div>
            <div
              className={`rr-roster-chip rr-roster-chip--mentor ${
                activeFilter === "spiritualMentor" ? "is-active" : ""
              }`}
            >
              <a onClick={spritualData}>
                <span className="rr-roster-chip-icon">
                  <Sparkles size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">Spiritual Mentor</span>
                  <span className="rr-roster-chip-count">{spritual_count}</span>
                </span>
              </a>
            </div>
            <div
              className={`rr-roster-chip rr-roster-chip--director ${
                spritualDirector_count === 0 ? "is-disabled" : ""
              }`}
            >
              <a
                onClick={() => {
                  if (spritualDirector_count !== 0) {
                    spritualDirectorData();
                    setPriestStatus(true);
                  }
                }}
                style={{
                  cursor:
                    spritualDirector_count !== 0 ? "pointer" : "default",
                }}
              >
                <span className="rr-roster-chip-icon">
                  <Church size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">
                    Spiritual Director
                  </span>
                  <span className="rr-roster-chip-count">
                    {spritualDirector_count}
                  </span>
                </span>
              </a>
            </div>
            <div
              className={`rr-roster-chip rr-roster-chip--services ${
                activeFilter === "service" ? "is-active" : ""
              }`}
            >
              <a onClick={serviceData}>
                <span className="rr-roster-chip-icon">
                  <FolderOpen size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">Services</span>
                  <span className="rr-roster-chip-count">{service_count}</span>
                </span>
              </a>
            </div>
            <div
              className={`rr-roster-chip rr-roster-chip--talks ${
                activeFilter === "talk" ? "is-active" : ""
              }`}
            >
              <a onClick={talkData}>
                <span className="rr-roster-chip-icon">
                  <Mic2 size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">Talks</span>
                  <span className="rr-roster-chip-count">{talk_count}</span>
                </span>
              </a>
            </div>
            <div className="rr-roster-chip rr-roster-chip--clear">
              <a onClick={clearFilter}>
                <span className="rr-roster-chip-icon">
                  <X size={16} />
                </span>
                <span className="rr-roster-chip-copy">
                  <span className="rr-roster-chip-label">Clear Filter</span>
                </span>
              </a>
            </div>
          </div>
        ) : null}

          <CustomDataTable
            key={`table-${activeFilter || "all"}-${resetKey}-${retreatDetail?.retreatCloseStatus}`}
            loading={LoadData}
            data={retreatRoastData}
            countPerPage={20}
            isServerSide={!missingValue}
            pagination={true}
            sortServer={!missingValue}
            total={total}
            columns={columns}
            dataFetchApi={getRetreatRoastData}
            selectedRetreat={activeFilter}
            pointerOnHover={true}
            highlightOnHover={true}
          />
        </div>

        <div className="rr-roster-docs program-directory-section">
          <h4 className="rr-roster-docs-title">Documents</h4>
          <div className="rr-roster-docs-grid">
          <div className="rr-roster-docs-left left-section">
            {!isTemp && !shouldHideUI && (
              <div className="rr-roster-docs-item item">
                <a href={`/create-program/${retreatId}`} target="_blank">
                  <button className="dirProgButtons">Create Program</button>
                </a>
                {retreatDetail.programStatus === "PUBLISH" && (
                  <a
                    href={`/program/${retreatId}`}
                    target="_blank"
                    className="view-link"
                  >
                    View Program
                  </a>
                )}
              </div>
            )}
            {!isTemp && !shouldHideUI && (
              <div className="rr-roster-docs-item item">
                <a href={`/create-directory/${retreatId}`} target="_blank">
                  <button className="dirProgButtons">Create Directory</button>
                </a>
                {retreatDetail.directoryStatus === "PUBLISH" && (
                  <a
                    href={`/directory/${retreatId}`}
                    target="_blank"
                    className="view-link"
                  >
                    View Directory
                  </a>
                )}
              </div>
            )}
          </div>

          <div className="rr-roster-docs-right right-section font-size">
            <div className="icon-group ">
              <span className="icon-label" title="Upload Directory File">
                DIRECTORY:
              </span>

              {retreatDetail.freeze === "FREEZE" ? (
                <div
                  className={`action-icons ${
                    retreatDetail.directoryFile ? "editRetreatDisabled" : ""
                  } editRetreatDisabled`}
                >
                  <i
                    className="mdi mdi-folder-open"
                    title="Upload Directory"
                  ></i>
                  {retreatDetail.directoryFile && (
                    <a
                      href={retreatDetail.directoryFile}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        title="Download Directory"
                        className="mdi mdi-download"
                        style={{ color: "#4cd964" }}
                      ></i>
                    </a>
                  )}
                </div>
              ) : (
                <div className={`action-icons`}>
                  <i
                    className="mdi mdi-folder-open"
                    title="Upload Directory"
                    onClick={(e) => {
                      e.preventDefault();
                      handleUploadDirectory(retreatDetail);
                    }}
                  ></i>
                  {retreatDetail.directoryFile && (
                    <a
                      href={retreatDetail.directoryFile}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        title="Download Directory"
                        className="mdi mdi-download"
                        style={{ color: "#4cd964" }}
                      ></i>
                    </a>
                  )}
                </div>
              )}
            </div>

            <div className="icon-group">
              <span className="icon-label" title="Upload Program File">
                PROGRAM:
              </span>

              {retreatDetail.freeze === "FREEZE" ? (
                <div className={`action-icons editRetreatDisabled`}>
                  <i
                    className="mdi mdi-calendar-multiselect"
                    title="Upload Program"
                  ></i>
                  {retreatDetail.programFile && (
                    <a
                      href={retreatDetail.programFile}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        title="Download Program"
                        className="mdi mdi-download"
                        style={{ color: "#4cd964" }}
                      ></i>
                    </a>
                  )}
                </div>
              ) : (
                <div className={`action-icons `}>
                  <i
                    className="mdi mdi-calendar-multiselect"
                    title="Upload Program"
                    onClick={(e) => {
                      e.preventDefault();
                      handleUploadProgram(retreatDetail);
                    }}
                  ></i>
                  {retreatDetail.programFile && (
                    <a
                      href={retreatDetail.programFile}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        title="Download Program"
                        className="mdi mdi-download"
                        style={{ color: "#4cd964" }}
                      ></i>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
          </div>
        </div>
        {showRegModal ? (
          <UpdateCouplePopUp
            showRegModal={showRegModal}
            setShowREgModal={setShowREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKCouple();
              setEdiUserIdClicked("");
              CloseCompose();
              refreshWithActiveFilter();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            getAllCouples={getRetreatRoastData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            // isTempUpload2={isTempUpload2}
            setIsTempUpload={setIsTempUpload}
            retreatDetail={retreatDetail}
            // setIsTempUpload2={setIsTempUpload2}
          />
        ) : null}
        {showModel ? renderEditRetreatModel() : null}
        {statusCheck ? (
          <AlertModal
            show={statusCheck}
            handleClose={closeStatusAlert}
            message={`Are you sure you want to ${
              Boolean(retreatDetail?.retreatCloseStatus) ? "reopen" : "close"
            } this retreat?`}
            actionFunction={retreatClose}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}

        {mailSendStatus ? (
          <AlertModal
            show={mailSendStatus}
            handleClose={closeSendMailAlert}
            message={`Are you sure you want to confirm "${
              retreatDetail?.myparish?.parish || ""
            }${
              retreatDetail?.language
                ? ` (${retreatDetail.language[0].toUpperCase()}${retreatDetail.language.slice(1)})`
                : ""
            }${
              retreatDetail?.location
                ? ` ${retreatDetail.location[0].toUpperCase()}${retreatDetail.location.slice(1)}`
                : ""
            }" Retreat ?`}
            actionFunction={mailSend}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}

        <DeleteModel
          show={show}
          content={
            <>
              <h5 className="mt-4 fw-bold">Couple Detail</h5>
              <div className="p-3 border rounded-3 bg-light shadow-sm">
                {/* His Details */}
                {(roast_id.hisFirstName ||
                  roast_id.hisLastName ||
                  roast_id.hisEmail) && (
                  <div className="mb-2">
                    <span className="fw-bold">His:</span>{" "}
                    {roast_id.hisFirstName} {roast_id.hisLastName}
                    {roast_id.hisEmail && (
                      <span className="text-muted"> – {roast_id.hisEmail}</span>
                    )}
                  </div>
                )}

                {/* Her Details */}
                {(roast_id.herFirstName ||
                  roast_id.herLastName ||
                  roast_id.herEmail) && (
                  <div>
                    <span className="fw-bold">Her:</span>{" "}
                    {roast_id.herFirstName} {roast_id.herLastName}
                    {roast_id.herEmail && (
                      <span className="text-muted"> – {roast_id.herEmail}</span>
                    )}
                  </div>
                )}
              </div>
            </>
          }
          handleClose={handleClose}
          DeleteData={DeleteData}
        ></DeleteModel>
        <FileUploadModal
          show={showUploadModal}
          handleClose={handleUploadModalClose}
          rowId={selectedRowId}
          handleUploadSuccess={handleUploadSuccess}
          fileType={fileType}
          onDeleteFile={handleDeleteFile}
          existingFileUrl={existingFileUrl}
          modalTitle={uploadModalTitle}
          userData={userData}
        />
        <OtherParishModal
          show={otherParishModalOpen}
          handleClose={() => setOtherParishModalOpen(false)}
          registerationData={roasterdData}
          setRegisterationData={setRoasterdData}
          setParishList={setParishList}
          parishList={parishList}
        />
        {sendFile && (
          <SendFileModal
            show={sendFile}
            handleClose={closePopUpSendFile}
            onSend={sendDirProgFile}
            loader={fileSendLoader}
            retreatRoastData={retreatRoastData}
            fileType={sendFileType}
          />
        )}

        {/* ── "Add Retreat Administrators" modal ── */}
        {removeAccessModal ? (
          <DeleteModel
            show={removeAccessModal}
            content={
              <>
                <h5 className="mt-4 fw-bold">Remove Retreat Administrator</h5>
                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  <div className="mb-2">
                    <span className="fw-bold">Administrator:</span>{" "}
                    <span className="text-muted">{editIndex}</span>
                  </div>
                </div>
              </>
            }
            handleClose={handleAccessRmvClose}
            DeleteData={removeAccessFromRetreat}
          />
        ) : null}

        {createRetAdmin ? (
          <CreateRetreatSubAdmin
            show={createRetAdmin}
            alertHeader={"Add Retreat Administrators"}
            alerMessage={""}
            allCoupleMails={allCoupleMails}
            allCoupleData={allCoupleData}
            ediUserIdClicked={adminEdiUserIdClicked}
            data={retreatAdminData}
            handlerAccessRmvShow={handlerAccessRmvShow}
            editRetreat={editRetreat}
            getAllCouples={getAllCouples}
            handleClose={() => {
              setCreateRetAdmin(false);
              setAdminEdiUserIdClicked("");
              setRetreatAdminData({ userEmails: [] });
              // Reflect changes in the visible table.
              refreshWithActiveFilter();
              getRetreatRoastData1();
            }}
          />
        ) : null}

        {talkAssignOpen && (
          <AssignTalkModal
            show={talkAssignOpen}
            handleClose={closeAssignPopUp}
            allRoasters={allRoasters}
            talksDataList={talksDataList}
            retreatRoastApi={retreatRoastApi}
            retreatId={retreatId}
            spritualDirector={spritualDirector}
            onAssignSuccess={() => {
              getRetreatRoastData1(); // refreshes counts + allRoasters
              refreshWithActiveFilter(); // refreshes the visible table
              spritualDirectorData();
            }}
          />
        )}

        {priestStatus ? (
          <AlertModal
            show={priestStatus}
            handleClose={closePriestAlert}
            message={
              spritualDirector ? (
                `<div
                  style={{
                    textAlign: "left",
                    maxHeight: "400px",
                    overflowY: "auto",
                    fontSize:"20px"
                  }}
                >
                  <p>
                    <strong>Spiritual Director (Priest) Details:</strong>
                  </p>
                  <p>
                    <strong>Priest Id:</strong>
                    ${spritualDirector.primaryKey || "N/A"}
                  </p>
                  <p>
                    <strong>Parish :</strong> ${spritualDirector?.parish?.parish || "N/A"}
                  </p>
            
                  <p>
                    <strong>First Name:</strong> ${spritualDirector.title ? spritualDirector.title + " " : ""}${spritualDirector.firstName}
                  </p>
                  <p>
                    <strong>Last Name:</strong> ${spritualDirector.lastName}
                  </p>
                  <p>
                    <strong>Email:</strong> ${spritualDirector.email}
                  </p>
                  <p>
                    <strong>Address:</strong>
                    ${spritualDirector.address || "N/A"}
                  </p>
                  <p>
                    <strong>City:</strong> ${spritualDirector.city || "N/A"}
                  </p>
                  <p>
                    <strong>State:</strong> ${spritualDirector.state || "N/A"}
                  </p>
                  <p>
                    <strong>Zip:</strong> ${spritualDirector.zip || "N/A"}
                  </p>
                </div>`
              ) : (
                <p>Not Assigned</p>
              )
            }
            actionFunction={closePriestAlert}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"Spiritual Director (Priest)"}
          />
        ) : null}

        {showStatus ? (
          <AlertModal
            show={showStatus}
            handleClose={handleCloseStatus}
            message={`Are you sure you want to ${
              alertData.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
            } this retreat?`}
            actionFunction={retreatChangeStatus}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
      </div>
    </>
  );
};

export default RetreatRoaster;
